"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99164],{

/***/ 79599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var processURLs = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        unLiveURL: data === null || data === void 0 ? void 0 : data.unliveUrl,
        subjectiveTestEvalURL: data === null || data === void 0 ? void 0 : data.subjectiveTestSeriesUrl,
        liveMentoringUrl: data === null || data === void 0 ? void 0 : data.liveRoom1On1Url,
        liveRoomRecordingUrl: data === null || data === void 0 ? void 0 : data.liveRoomRecordingUrl,
        doubtsBrowseUrl: data === null || data === void 0 ? void 0 : data.doubtBrowseUrl,
        lmpAddToCanvas: data === null || data === void 0 ? void 0 : data.lmpAddToCanvasEnable,
        lmpWebUrl: data === null || data === void 0 ? void 0 : data.lmpWebUrl,
        educatorDriveUrl: data === null || data === void 0 ? void 0 : data.educatorDriveUrl
    };
};
var useURLs = function(selector) {
    var key = "v1/constants/extras/";
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key), urls = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    var processedURLs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (urls) return processURLs(urls);
        return {};
    }, [
        urls
    ]);
    if (typeof selector === "function") return selector(processedURLs);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        urls: processedURLs
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useURLs);


/***/ }),

/***/ 13909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95477);




var StyledCircularProgress = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1622i1o0",
    label: "StyledCircularProgress"
})("color:", function(param) {
    var $customColor = param.$customColor;
    return $customColor;
}, ";");
var CircularLoader = function(param) {
    var color = param.color, size = param.size, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledCircularProgress, {
        $customColor: color,
        size: size,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircularLoader);
CircularLoader.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
CircularLoader.defaultProps = {
    color: "var(--color-i-green)",
    size: 40,
    className: ""
};


/***/ }),

/***/ 75591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_FutureImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56827);




/* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ 

var StyledImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_FutureImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "enlmcnc0",
    label: "StyledImage"
})("height:100%;width:100%;transform:scale(", function(param) {
    var $noCrop = param.$noCrop;
    return $noCrop && "1" || "1.02";
}, ");background-color:var(--color-divider);object-fit:cover;@media only screen and (max-width:47.95em){transform:scale(1);}");
var StyledDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "enlmcnc1",
    label: "StyledDiv"
})("height:", function(param) {
    var $orientation = param.$orientation;
    return $orientation === "vertical" && "152px";
}, ";width:272px;object-fit:cover;position:relative;background-color:var(--color-divider);border-radius:", function(param) {
    var $borderRadius = param.$borderRadius;
    return $borderRadius;
}, ";overflow:hidden;");
var Thumbnail = function(_param) {
    var imgUrl = _param.imgUrl, _orientation = _param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, _className = _param.className, className = _className === void 0 ? "" : _className, _children = _param.children, children = _children === void 0 ? null : _children, _visibleByDefault = _param.visibleByDefault, visibleByDefault = _visibleByDefault === void 0 ? false : _visibleByDefault, _onClick = _param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _noCrop = _param.noCrop, noCrop = _noCrop === void 0 ? false : _noCrop, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? "0px" : _borderRadius, _alt = _param.alt, alt = _alt === void 0 ? "Thumbnail" : _alt, isUnoptimized = _param.isUnoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, _layout = _param.layout, layout = _layout === void 0 ? "fill" : _layout, _width = _param.width, width = _width === void 0 ? 272 : _width, _height = _param.height, height = _height === void 0 ? 152 : _height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "imgUrl",
        "orientation",
        "className",
        "children",
        "visibleByDefault",
        "onClick",
        "noCrop",
        "borderRadius",
        "alt",
        "isUnoptimized",
        "priority",
        "layout",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(StyledDiv, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        $orientation: orientation,
        className: "".concat(className, " batch-thumbnail"),
        onClick: onClick,
        $borderRadius: borderRadius
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledImage, {
                priority: priority,
                visibleByDefault: visibleByDefault,
                src: imgUrl,
                alt: alt,
                orientation: orientation,
                $noCrop: noCrop,
                decoding: "async",
                layout: layout,
                unoptimized: isUnoptimized,
                width: width,
                height: height
            }),
            children
        ]
    }));
};
Thumbnail.defaultProps = {
    isUnoptimized: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Thumbnail);


/***/ }),

/***/ 90347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52420);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95934);
/* harmony import */ var _api_hooks_useURLs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79599);








var CLX = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])("iframe", {
    target: "e1mzpn7l0",
    label: "CLX"
})("position:fixed;top:0px;width:100vw;height:100vh;bottom:0px;left:0px;z-index:3;");
var Iframe = function(param) {
    var files = param.files, removeFile = param.removeFile, finishUpload = param.finishUpload, id = param.id, mode = param.mode, file = param.file, setMode = param.setMode, goalUID = param.goalUID, topicGroups = param.topicGroups, isEducator = param.isEducator;
    var accessToken = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(param) {
        var auth = param.auth;
        return auth.accessToken;
    });
    var url = (0,_api_hooks_useURLs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(urls) {
        return urls.educatorDriveUrl;
    });
    var driveDetails = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(param) {
        var templates = param.templates;
        return isEducator ? file : templates.addEditTemplate.driveDetails;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var handleWidgetsVisibility = function(visible) {
        var ref, ref1;
        var fwVisible = visible ? "show" : "hide";
        var intercomVisible = !visible;
        (ref = window.FreshworksWidget) === null || ref === void 0 ? void 0 : ref.call(window, fwVisible);
        (ref1 = window.Intercom) === null || ref1 === void 0 ? void 0 : ref1.call(window, "update", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, window.intercomSettings), {
            hide_default_launcher: intercomVisible
        }));
    };
    var onMessageReceived = function(e) {
        if (e.data.liveClassReady) {
            var ref, ref1;
            handleWidgetsVisibility(false);
            var message = {
                accessToken: accessToken,
                apiHost: "https://unacademy.com/api/".slice(0, -1),
                parentUID: driveDetails.uid,
                isCloud: true,
                mode: mode,
                files: files,
                fileInfo: file,
                isTemplateCreation: true
            };
            if (mode === "edit") message.contentTaggingData = {
                isEnabled: true,
                topicGroups: topicGroups,
                goalUid: goalUID
            };
            (ref = document.getElementById("driveIframe")) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.postMessage(message, "*");
        }
        if (e.data.closeIframe) {
            handleWidgetsVisibility(true);
            setMode === null || setMode === void 0 ? void 0 : setMode("upload");
            if (e.data.files[0]) finishUpload === null || finishUpload === void 0 ? void 0 : finishUpload(id, e.data.files[0]);
            removeFile === null || removeFile === void 0 ? void 0 : removeFile();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isLoaded) setIsLoaded(true);
        window.addEventListener("message", onMessageReceived);
        return function() {
            window.removeEventListener("message", onMessageReceived);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!isLoaded) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CLX, {
        src: url,
        title: "iframe",
        id: "driveIframe",
        webkitallowfullscreen: "true",
        allowFullScreen: true,
        width: "100%",
        height: "100%",
        frameBorder: "no"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Iframe);
Iframe.propTypes = {
    setMode: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    removeFile: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    finishUpload: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    files: prop_types__WEBPACK_IMPORTED_MODULE_7___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_7___default().any)),
    mode: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    file: prop_types__WEBPACK_IMPORTED_MODULE_7___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_7___default().any)),
    goalUID: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    topicGroups: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    isEducator: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
Iframe.defaultProps = {
    files: null,
    file: null,
    goalUID: "",
    topicGroups: "",
    isEducator: false
};


/***/ }),

/***/ 88074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ InfiniteList_InfiniteList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Base/CircularLoader/CircularLoader.jsx
var CircularLoader = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/hooks/useInfiniteScrollHandler.js
var useInfiniteScrollHandler = __webpack_require__(7418);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Skeletons/CourseCard/CourseCarousel.jsx + 1 modules
var CourseCarousel = __webpack_require__(10914);
;// CONCATENATED MODULE: ./src/components/Skeletons/index.js
/* eslint-disable import/prefer-default-export */ 

;// CONCATENATED MODULE: ./src/components/Composite/InfiniteList/InfiniteList.jsx



/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react-hooks/exhaustive-deps */ 






var ProgressWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecbt2ti0",
    label: "ProgressWrapper"
})("grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";width:484px;margin:auto;height:120px;display:flex;justify-content:center;align-items:center;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){width:100%;grid-column:span 10;}");
var InfiniteList = function(props) {
    var onScrollEnd = function onScrollEnd() {
        if (data && !data.isFetching && isFetching) {
            if (data.next) {
                var loadPromise = loadMore();
                if (!loadPromise) return;
                loadPromise.then(function() {
                    setIsFetching(false);
                });
            } else {
                setIsFetching(false);
            }
        }
    };
    var ref;
    var data = props.data, _renderItem = props._renderItem, loadMore = props.loadMore, scrollElement = props.scrollElement, loaderType = props.loaderType, rowItems = props.rowItems, gridColumn = props.gridColumn, dataKey = props.dataKey, loaderColor = props.loaderColor, RenderItem = props.RenderItem, getItemKey = props.getItemKey, extraProps = props.extraProps;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useInfiniteScrollHandler/* default */.Z)(// eslint-disable-next-line no-use-before-define
    onScrollEnd, scrollElement), 2), isFetching = ref1[0], setIsFetching = ref1[1];
    react.useEffect(function() {
        setIsFetching(false);
    }, [
        dataKey
    ]);
    var getLoader = function() {
        if (loaderType === "course" || loaderType === "batchGroup") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCarousel/* default */.Z, {
                number: rowItems,
                gridColumn: gridColumn
            });
        }
        if (loaderType === "progress") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressWrapper, {
                gridColumn: gridColumn,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularLoader/* default */.Z, {
                    color: loaderColor
                })
            });
        }
    };
    if (!data) return null;
    var renderLoader = data.isFetching && loaderType !== "disabled";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            (ref = data.results) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                if (RenderItem) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderItem, (0,_object_spread/* default */.Z)({
                    item: item,
                    index: index
                }, extraProps), getItemKey(item, index));
                return _renderItem(item, index);
            }),
            renderLoader ? getLoader() : null
        ]
    });
};
InfiniteList.propTypes = {
    _renderItem: (prop_types_default()).func,
    RenderItem: (prop_types_default()).elementType,
    loadMore: (prop_types_default()).func,
    data: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    scrollElement: prop_types_default().objectOf((prop_types_default()).any),
    rowItems: (prop_types_default()).number,
    loaderType: prop_types_default().oneOf([
        "progress",
        "course",
        "disabled"
    ]),
    gridColumn: (prop_types_default()).string,
    dataKey: (prop_types_default()).string,
    loaderColor: (prop_types_default()).string,
    getItemKey: (prop_types_default()).func,
    extraProps: prop_types_default().objectOf((prop_types_default()).any)
};
InfiniteList.defaultProps = {
    loadMore: function() {
        return null;
    },
    scrollElement: null,
    loaderType: "progress",
    rowItems: 3,
    gridColumn: "span 10",
    dataKey: "",
    loaderColor: "var(--color-i-green)",
    getItemKey: function(_, index) {
        return index;
    },
    extraProps: {},
    _renderItem: function() {},
    RenderItem: null
};
/* harmony default export */ var InfiniteList_InfiniteList = (InfiniteList);


/***/ }),

/***/ 73993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ getIsPartnerEducatorBatch; },
/* harmony export */   "DJ": function() { return /* binding */ getOfferEndMessage; },
/* harmony export */   "Eg": function() { return /* binding */ getBatchType; },
/* harmony export */   "Ej": function() { return /* binding */ DEFAULT_SUBJECT_VALUE; },
/* harmony export */   "Ic": function() { return /* binding */ getBatchReferralInStorage; },
/* harmony export */   "Lk": function() { return /* binding */ SESSION_TYPE_MAP; },
/* harmony export */   "MB": function() { return /* binding */ EDUCATOR_TYPES; },
/* harmony export */   "Rf": function() { return /* binding */ FETCH_STORE_SYLLABUS_VALUES; },
/* harmony export */   "Sf": function() { return /* binding */ getIsStoreSyllabus; },
/* harmony export */   "Tv": function() { return /* binding */ BATCH_CONTENT_TYPE_MAP; },
/* harmony export */   "ax": function() { return /* binding */ getEnrollmentEndMessage; },
/* harmony export */   "bL": function() { return /* binding */ getIsStoreModule; },
/* harmony export */   "gx": function() { return /* binding */ getHasStorePurchase; },
/* harmony export */   "ko": function() { return /* binding */ getAccessEndDate; },
/* harmony export */   "nQ": function() { return /* binding */ getIsStorePath; },
/* harmony export */   "oc": function() { return /* binding */ LESSON_ITEMS_ON_BATCH_PAGE; },
/* harmony export */   "tn": function() { return /* binding */ getSkuBasedEventProps; },
/* harmony export */   "v7": function() { return /* binding */ BATCH_CONTENT_TYPE_ID; },
/* harmony export */   "z_": function() { return /* binding */ setBatchReferralInStorage; },
/* harmony export */   "zm": function() { return /* binding */ getActiveSku; }
/* harmony export */ });
/* unused harmony exports BATCH_TYPE, removeStoreBatchInStorage */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97903);
/* harmony import */ var _utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29626);






var BATCH_CONTENT_TYPE_ID = 500;
var BATCH_TYPE = {
    MODULE: "Module",
    PLAYLIST: "Playlist"
};
var BATCH_CONTENT_TYPE_MAP = {
    LIVE: "Live",
    RECORDED: "Recorded",
    LIVE_RECORDED: "Live + Recorded",
    HYBRID: "HYBRID",
    CENTER: "Center",
    OFFLINE: "Offline"
};
var STORE_BATCH_KEY = "storeBatchReferralCodes";
var SESSION_TYPE_MAP = {
    ALL: "1",
    CLASSES: "2",
    TESTS: "3"
};
var LESSON_ITEMS_ON_BATCH_PAGE = {
    START: 0,
    END: 3
};
var DEFAULT_SUBJECT_VALUE = "ALL";
var EDUCATOR_TYPES = {
    PLUS: 1,
    PARTNER: 2
};
var FETCH_STORE_SYLLABUS_VALUES = {
    LIMIT: 10,
    OFFSET: 0
};
var getIsStorePath = function(route) {
    return route.indexOf("store/batch/") >= 0;
};
var getActiveSku = function(purchaseInfo) {
    var skus = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : purchaseInfo.skus;
    return skus === null || skus === void 0 ? void 0 : skus[0];
};
var getIsPartnerEducatorBatch = function(batchDetails) {
    return (batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.educatorType) === EDUCATOR_TYPES.PARTNER;
};
var getIsStoreSyllabus = function(param) {
    var additionalFeatures = param.additionalFeatures;
    return additionalFeatures ? (additionalFeatures === null || additionalFeatures === void 0 ? void 0 : additionalFeatures.indexOf(BATCH_TYPE.PLAYLIST)) !== -1 : false;
};
var getIsStoreModule = function(param) {
    var additionalFeatures = param.additionalFeatures;
    return additionalFeatures ? (additionalFeatures === null || additionalFeatures === void 0 ? void 0 : additionalFeatures.indexOf(BATCH_TYPE.MODULE)) !== -1 : false;
};
var getHasStorePurchase = function(batchUID, purchaseInfo) {
    var ref;
    var purchases = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : (ref = purchaseInfo.metaInfo) === null || ref === void 0 ? void 0 : ref.latestUserSkusTypeWise;
    if (purchases && purchases[BATCH_CONTENT_TYPE_ID]) {
        var batchPurchases = purchases[BATCH_CONTENT_TYPE_ID];
        var currentBatchActivePurchase = batchPurchases.find(function(purchase) {
            return purchase.objectUid === batchUID;
        });
        return !!(currentBatchActivePurchase && !(0,_utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentBatchActivePurchase));
    }
    return false;
};
var getEnrollmentEndMessage = function(date) {
    if (!date) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true, 7, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Enrolment ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Enrolment ends in ".concat(relativeDate, " days");
    }
    return "Enrolment ends on ".concat(relativeDate);
};
var getOfferEndMessage = function(date) {
    if (!date) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true, 7, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Offer ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Offer ends in ".concat(relativeDate, " days");
    }
    return "Offer ends on ".concat(relativeDate);
};
var getAccessEndDate = function(purchaseInfo, batchUID, isStoreRoute, isSubscribed) {
    var ref;
    var activeSku = getActiveSku(purchaseInfo);
    if (activeSku && !(0,_utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(activeSku) && isStoreRoute && !isSubscribed) {
        return (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRegularDate */ .Wg)(activeSku === null || activeSku === void 0 ? void 0 : activeSku.accessEndDate);
    }
    var purchases = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : (ref = purchaseInfo.metaInfo) === null || ref === void 0 ? void 0 : ref.latestUserSkusTypeWise;
    if (purchases && purchases[BATCH_CONTENT_TYPE_ID]) {
        var batchPurchases = purchases[BATCH_CONTENT_TYPE_ID];
        var currentBatchActivePurchase = batchPurchases.find(function(purchase) {
            return purchase.objectUid === batchUID;
        });
        return currentBatchActivePurchase && (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRegularDate */ .Wg)(currentBatchActivePurchase.expiredAt);
    }
};
var getBatchType = function(contentType) {
    if (contentType === BATCH_CONTENT_TYPE_MAP.LIVE_RECORDED || contentType === BATCH_CONTENT_TYPE_MAP.RECORDED) {
        return "Recorded";
    }
    return contentType;
};
var getSkuBasedEventProps = function(activeSku, batchDetails) {
    return {
        entity_content_type: "Batch",
        entity_title: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.name,
        entity_uid: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.uid,
        last_primary_source: "Store",
        subscription_type: "Store Subscription",
        offer_price: activeSku === null || activeSku === void 0 ? void 0 : activeSku.price,
        offer_end_date: (activeSku === null || activeSku === void 0 ? void 0 : activeSku.priceEffectiveTill) || undefined,
        subscription_price: (activeSku === null || activeSku === void 0 ? void 0 : activeSku.maxRetailPrice) || (activeSku === null || activeSku === void 0 ? void 0 : activeSku.price),
        subscription_duration: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDateDifference */ .hM)(activeSku === null || activeSku === void 0 ? void 0 : activeSku.accessEndDate),
        entity_content_subtype: getBatchType(batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.contentType),
        educator_type: (batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.educatorType) === EDUCATOR_TYPES.PARTNER ? "Partner" : "Plus"
    };
};
var getBatchReferralInStorage = function(batchUID) {
    try {
        var referralCodesStr = (0,_utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STORE_BATCH_KEY);
        var referralCodes = !!referralCodesStr && JSON.parse(referralCodesStr);
        return referralCodes && referralCodes[batchUID];
    } catch (e) {
        return null;
    }
};
var setBatchReferralInStorage = function(batchUID, code) {
    try {
        var referralCodesStr = (0,_utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STORE_BATCH_KEY);
        var referralCodes = !!referralCodesStr && JSON.parse(referralCodesStr);
        sessionStorage.setItem(STORE_BATCH_KEY, JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, referralCodes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, batchUID, code))));
    } catch (e) {
        return null;
    }
};
var removeStoreBatchInStorage = function() {
    sessionStorage.removeItem(STORE_BATCH_KEY);
};



/***/ }),

/***/ 62411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85620);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10076);
/* harmony import */ var _base_Divider_Divider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46736);
/* harmony import */ var _icon_Download__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83583);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(751);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17579);
/* harmony import */ var _events_segmentStorage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71250);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87936);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_subscription__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58063);
/* harmony import */ var _api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96487);

/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 














var MenuItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("li", {
    target: "eecwq5h0",
    label: "MenuItem"
})("display:flex;align-items:center;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_4B */ .t8.BM, ";cursor:pointer;");
var StyledDivider = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Divider_Divider__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "eecwq5h1",
    label: "StyledDivider"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_4B */ .t8.BM, ";");
var Head = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("li", {
    target: "eecwq5h2",
    label: "Head"
})("display:flex;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_2B */ .t8.Rw, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_3B */ .t8.N, ";");
var DownloadPDF = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_icon_Download__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "eecwq5h3",
    label: "DownloadPDF"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_3B */ .t8.N, ";margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_10__/* .Spacings.SPACING_4B */ .t8.BM, ";");
var PDFDownload = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var selectedLesson = param.selectedLesson, course = param.course, goal = param.goal, handleClose = param.handleClose, _isBatch = param.isBatch, isBatch = _isBatch === void 0 ? false : _isBatch, _me = param.me, me = _me === void 0 ? null : _me, _source = param.source, source = _source === void 0 ? null : _source, _isBatchGroup = param.isBatchGroup, isBatchGroup = _isBatchGroup === void 0 ? false : _isBatchGroup;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7;
    var forPlus = course.forPlus, forSubscription = course.forSubscription, isEnrolled = course.isEnrolled;
    var segGoalUID = goal.uid, goalName = goal.name, goalLanguage = goal.language;
    var goalUID = (0,_api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_13__/* .useSelectedGoalUID */ .Xm)() || segGoalUID;
    var _$ref8;
    var _$ref9 = (_$ref8 = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_12__/* .getPlusSubscriptionInfo */ .JL)(goalUID))) !== null && _$ref8 !== void 0 ? _$ref8 : {}, _subscription = _$ref9.subscription, subscription = _subscription === void 0 ? {} : _subscription, expiredAt = _$ref9.expiredAt, timeRemaining = _$ref9.timeRemaining;
    var lesssonName = selectedLesson.name, lessonUID = selectedLesson.uid, lessonAuthor = selectedLesson.author;
    var eventData = {
        goal_uid: goalUID,
        name: goalName,
        language: goalLanguage,
        session_id: new Date().getTime(),
        subscription_duration: subscription.duration,
        subscription_end_date: expiredAt,
        is_subscription_active: timeRemaining > 0,
        lesson_uid: lessonUID,
        lesson_title: lesssonName,
        educator_uid: lessonAuthor === null || lessonAuthor === void 0 ? void 0 : lessonAuthor.uid,
        educator_username: lessonAuthor === null || lessonAuthor === void 0 ? void 0 : lessonAuthor.name,
        is_plus: forPlus,
        is_special: forPlus && !forSubscription,
        is_enrolled: isEnrolled,
        last_primary_source: _events_segmentStorage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getItem */ .Z.getItem("lps")
    };
    var _$ref10 = selectedLesson || {}, slides = _$ref10.slides, type = _$ref10.type;
    var courseUID = (selectedLesson === null || selectedLesson === void 0 ? void 0 : selectedLesson.courseUID) || (selectedLesson === null || selectedLesson === void 0 ? void 0 : (_$ref = selectedLesson.programme) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.course) === null || _$ref1 === void 0 ? void 0 : _$ref1.uid) || (selectedLesson === null || selectedLesson === void 0 ? void 0 : (_$ref2 = selectedLesson.properties) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.programme) === null || _$ref3 === void 0 ? void 0 : _$ref3.uid);
    var courseSlug = (selectedLesson === null || selectedLesson === void 0 ? void 0 : selectedLesson.courseSlug) || (selectedLesson === null || selectedLesson === void 0 ? void 0 : (_$ref4 = selectedLesson.programme) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.course) === null || _$ref5 === void 0 ? void 0 : _$ref5.slug) || (selectedLesson === null || selectedLesson === void 0 ? void 0 : (_$ref6 = selectedLesson.properties) === null || _$ref6 === void 0 ? void 0 : (_$ref7 = _$ref6.programme) === null || _$ref7 === void 0 ? void 0 : _$ref7.slug) || "-";
    var goToCoursePage = function() {
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("/".concat(type === "post" ? "course" : "test-series", "/[slug]/[courseUID]"), "/".concat(type === "post" ? "course" : "test-series", "/").concat(courseSlug, "/").concat(courseUID));
        handleClose();
    };
    var openWith = function() {
        eventData.download_type = "With annotations";
        if (source === "learnerCoursePage") {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_9__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_7__/* .PDF_DOWNLOAD */ .siE, eventData);
            (0,_actions_analytics__WEBPACK_IMPORTED_MODULE_9__/* .analyticsApi */ .Yu)({
                event: "PPT_DOWNLOAD",
                data: "true",
                name: "PPT_DOWNLOAD",
                isAnnotationOn: true,
                me: me
            }, "downloadPDF");
        }
        window.open(slides === null || slides === void 0 ? void 0 : slides.withAnnotations, "_blank");
        handleClose();
    };
    var openWithout = function() {
        eventData.download_type = "Without annotations";
        if (source === "learnerCoursePage") {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_9__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_7__/* .PDF_DOWNLOAD */ .siE, eventData);
            (0,_actions_analytics__WEBPACK_IMPORTED_MODULE_9__/* .analyticsApi */ .Yu)({
                event: "PPT_DOWNLOAD",
                data: "false",
                name: "PPT_DOWNLOAD",
                isAnnotationOn: false,
                me: me
            }, "downloadPDF");
        }
        window.open(slides === null || slides === void 0 ? void 0 : slides.withoutAnnotations, "_blank");
        handleClose();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
        children: [
            slides && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(Head, {
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(DownloadPDF, {
                                size: "20px",
                                color: "var(--color-text-primary)"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                color: "var(--color-text-primary)",
                                children: "Download PDF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(StyledDivider, {})
                ]
            }),
            (slides === null || slides === void 0 ? void 0 : slides.withAnnotations) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(MenuItem, {
                ref: ref,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
                    onClick: openWith,
                    className: "slides",
                    "data-href": slides === null || slides === void 0 ? void 0 : slides.withAnnotations,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        color: "var(--color-text-primary)",
                        children: "With annotation"
                    })
                })
            }) : null,
            (slides === null || slides === void 0 ? void 0 : slides.withoutAnnotations) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(MenuItem, {
                ref: ref,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
                    onClick: openWithout,
                    "data-href": slides === null || slides === void 0 ? void 0 : slides.withoutAnnotations,
                    className: "slides",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        color: "var(--color-text-primary)",
                        children: "Without annotation"
                    })
                })
            }) : null,
            isBatch && !isBatchGroup && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(MenuItem, {
                ref: ref,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)("div", {
                    onClick: goToCoursePage,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        color: "var(--color-text-primary)",
                        children: "Go to course page"
                    })
                })
            })
        ]
    });
});
PDFDownload.displayName = "PDFDownload";
PDFDownload.propTypes = {
    selectedLesson: prop_types__WEBPACK_IMPORTED_MODULE_15___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_15___default().any)),
    handleClose: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().func.isRequired),
    isBatch: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().bool),
    isBatchGroup: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().bool),
    me: prop_types__WEBPACK_IMPORTED_MODULE_15___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_15___default().any)),
    source: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().string),
    course: prop_types__WEBPACK_IMPORTED_MODULE_15___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_15___default().any)),
    goal: prop_types__WEBPACK_IMPORTED_MODULE_15___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_15___default().any))
};
PDFDownload.defaultProps = {
    selectedLesson: {},
    isBatch: false,
    isBatchGroup: false,
    me: null,
    source: null,
    course: {},
    goal: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (PDFDownload);


/***/ }),

/***/ 91244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35415);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _constants_quiz__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47355);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43135);
/* harmony import */ var _base_P2_P2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72560);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80867);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding-top: ",
        ";\n      border-top: 1px solid var(--color-i-divider);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ef2jzpp0",
    label: "StyledButton"
})("font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.SMALL */ .F3.HC, ";margin-left:auto;margin-right:", function(props) {
    return !props.$showNoQuestionsBoxMessage ? _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_9B */ .t8.No : "";
}, ";&:hover{box-shadow:none;}");
var StyledP2 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P2_P2__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "ef2jzpp1",
    label: "StyledP2"
})("margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var ButtonWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ef2jzpp2",
    label: "ButtonWrapper"
})("button{margin-right:0;}", function(props) {
    return props.$showNoQuestionsBoxMessage && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject(), _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw);
});
var LABELS = {
    REVIEW: "Review",
    ADD_QUESTION: "Add question",
    CREATE_TEST: "Create test",
    EDIT_QUESTIONS: "Edit questions",
    CREATE_QUIZ: "Create quiz"
};
var getTestStateInfo = function(contentState, creationType, sessionUID) {
    switch(contentState){
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .TEST_CONTENT_STATE.TEMPLATE_PENDING */ .z5.TEMPLATE_PENDING:
            return {
                label: LABELS.CREATE_TEST,
                url: "/educator/test/".concat(sessionUID, "?creationType=test")
            };
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .TEST_CONTENT_STATE.ADD_QUESTION */ .z5.ADD_QUESTION:
            return {
                label: LABELS.ADD_QUESTION,
                url: "/educator/test/".concat(sessionUID)
            };
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .TEST_CONTENT_STATE.EDIT_QUESTION */ .z5.EDIT_QUESTION:
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .TEST_CONTENT_STATE.QUESTION_COMPLETED */ .z5.QUESTION_COMPLETED:
            return {
                label: LABELS.EDIT_QUESTIONS,
                url: creationType === _constants_quiz__WEBPACK_IMPORTED_MODULE_4__/* .TEST_CREATION_FLOW_TYPE.AUTOFILLED_CREATION */ .QI.AUTOFILLED_CREATION ? "/educator/test/autofill/".concat(sessionUID) : "/educator/test/edit/".concat(sessionUID)
            };
        default:
            return {};
    }
};
var getQuizStateInfo = function(contentState, sessionUID) {
    switch(contentState){
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .QUIZ_CONTENT_STATE.CREATE_QUIZ */ .Ah.CREATE_QUIZ:
            return {
                label: LABELS.CREATE_QUIZ,
                url: "/educator/quiz/details/".concat(sessionUID)
            };
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .QUIZ_CONTENT_STATE.ADD_QUESTION */ .Ah.ADD_QUESTION:
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .QUIZ_CONTENT_STATE.EDIT_QUESTION */ .Ah.EDIT_QUESTION:
            return {
                label: LABELS.ADD_QUESTION,
                url: "/educator/quiz/edit/".concat(sessionUID)
            };
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .QUIZ_CONTENT_STATE.QUESTION_COMPLETED */ .Ah.QUESTION_COMPLETED:
            return {
                label: LABELS.REVIEW,
                url: "/educator/quiz/review/".concat(sessionUID, "/?exitFrom=top")
            };
        default:
            return {};
    }
};
var openURL = function(url) {
    return window.open(url, "_blank");
};
var handleStateClick = function() {
    var URL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", sourceURL = arguments.length > 1 ? arguments[1] : void 0;
    return function() {
        if (URL.includes("?") && sourceURL) {
            openURL("".concat(URL, "&source=").concat(sourceURL));
            return;
        }
        if (sourceURL) {
            openURL("".concat(URL, "/?source=").concat(sourceURL));
            return;
        }
        openURL(URL);
    };
};
var StatusButton = function(param) {
    var sourceURL = param.sourceURL, isTestSeries = param.isTestSeries, contentState = param.contentState, creationType = param.creationType, sessionUID = param.sessionUID, quizType = param.quizType, showNoQuestionsBoxMessage = param.showNoQuestionsBoxMessage;
    var statusInfo = isTestSeries ? getTestStateInfo(contentState, creationType, sessionUID) : getQuizStateInfo(contentState, sessionUID);
    if (quizType === _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .quizSecondaryType.TEST */ .vC.TEST && !isTestSeries) statusInfo = {
        label: "View questions",
        url: "/educator/test/review/".concat(sessionUID, "?source=").concat(sourceURL)
    };
    return (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.url) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(ButtonWrapper, {
        $showNoQuestionsBoxMessage: showNoQuestionsBoxMessage,
        children: [
            showNoQuestionsBoxMessage && statusInfo.label !== LABELS.REVIEW && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        src: "info-icon.svg",
                        alt: "infoIcon",
                        width: "24",
                        height: "24"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledP2, {
                        children: "No questions added "
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledButton, {
                $showNoQuestionsBoxMessage: showNoQuestionsBoxMessage,
                label: statusInfo.label,
                color: "var(--color-text-primary)",
                maxHeight: "sm",
                grid: 3,
                onClick: handleStateClick(statusInfo.url, sourceURL)
            })
        ]
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (StatusButton);
StatusButton.propTypes = {
    sourceURL: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    isTestSeries: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool.isRequired),
    contentState: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number.isRequired),
    creationType: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    sessionUID: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string.isRequired),
    quizType: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number)
};
StatusButton.defaultProps = {
    sourceURL: null,
    quizType: 0,
    creationType: null
};


/***/ }),

/***/ 55253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Course_Week; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/P1/P1.jsx
var P1 = __webpack_require__(85620);
// EXTERNAL MODULE: ./src/components/Base/H4/H4.jsx
var H4 = __webpack_require__(64250);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/components/Composite/Dialog/Dialog.tsx + 1 modules
var Dialog = __webpack_require__(76920);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/redux/actions/saved.js
var saved = __webpack_require__(9113);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/reduxHooks.js + 1 modules
var reduxHooks = __webpack_require__(88738);
// EXTERNAL MODULE: ./src/stores/toggleables.js
var toggleables = __webpack_require__(85690);
// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/models/Item.js
var Item = __webpack_require__(46571);
// EXTERNAL MODULE: ./src/redux/actions/educator.js
var educator = __webpack_require__(13237);
// EXTERNAL MODULE: ./src/redux/actions/quizTaking.js
var quizTaking = __webpack_require__(22609);
// EXTERNAL MODULE: ./src/components/Icons/MoreVert.jsx
var MoreVert = __webpack_require__(1218);
// EXTERNAL MODULE: ./src/components/Icons/Play.jsx
var Play = __webpack_require__(99102);
// EXTERNAL MODULE: ./src/components/Container/Course/LeftIcon.jsx + 1 modules
var LeftIcon = __webpack_require__(98901);
// EXTERNAL MODULE: ./src/components/Container/Course/StatusButton.jsx
var StatusButton = __webpack_require__(91244);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/hooks/useEducatorContext.js
var useEducatorContext = __webpack_require__(49465);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/components/Educator/Container/TemplateSchedule/ClassMetaData.jsx
var ClassMetaData = __webpack_require__(1682);
// EXTERNAL MODULE: ./src/components/Educator/Container/AutoDPP/Statistics.jsx
var Statistics = __webpack_require__(1834);
// EXTERNAL MODULE: ./src/components/Educator/Container/AutoDPP/useDPPEvents.js
var useDPPEvents = __webpack_require__(34958);
;// CONCATENATED MODULE: ./src/components/Educator/Container/CourseDetails/ItemCard.jsx

























var CourseInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e1x742gs0",
    label: "CourseInfo"
})("margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var ItemInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs1",
    label: "ItemInfo"
})("width:365px;margin-right:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";");
var MenuButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs2",
    label: "MenuButton"
})("display:flex;height:22px;");
var MenuWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs3",
    label: "MenuWrapper"
})("display:flex;align-items:center;margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";border:1px solid var(--color-i-gray-v2);border-radius:3px;padding:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";&:hover{background-color:var(--color-i-gray-v2);}");
var StatsDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs4",
    label: "StatsDiv"
})("display:flex;");
var Flex = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs5",
    label: "Flex"
})("display:flex;align-items:center;");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs6",
    label: "Wrapper"
})("padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";background-color:var(--color-base-1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";box-shadow:", styleConstants/* Spacings.SPACING_0B */.t8.NE, " ", styleConstants/* Spacings.SPACING_4B */.t8.BM, " ", styleConstants/* Spacings.SPACING_8B */.t8.B3, " var(--color-shadow);display:flex;flex-direction:column;grid-column:9/25;justify-content:space-between;cursor:pointer;:hover{box-shadow:0 ", styleConstants/* Spacings.SPACING_1B */.t8.MK, " ", styleConstants/* Spacings.SPACING_2B */.t8.Rw, "      var(--color-shadow);}transition:box-shadow 0.2s ease-in-out;");
var ClassItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs7",
    label: "ClassItemWrapper"
})("display:flex;justify-content:space-between;");
var ClassMeta = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(ClassMetaData/* default */.Z, {
    target: "e1x742gs8",
    label: "ClassMeta"
})("margin-left:", styleConstants/* Spacings.SPACING_16B */.t8.hN, ";");
var AutoDppButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "e1x742gs9",
    label: "AutoDppButton"
})("border-radius:4px;font-size:14px;height:40px;");
var AutoDppStatsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1x742gs10",
    label: "AutoDppStatsWrapper"
})("display:flex;margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";padding-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";border-top:solid 1px;border-top-color:var(--color-i-gray-v2);");
var liveButtonClick = function(classUID, openDrawer) {
    return function(e) {
        e.stopPropagation();
        openDrawer();
        (0,pushRoute/* default */.Z)("/educator/live/[classUID]", "/educator/live/".concat(classUID));
    };
};
var ItemCard = function(param) {
    var lesson = param.lesson, onItemClick = param.onItemClick, isTestSeries = param.isTestSeries, setAnchorEl = param.setAnchorEl, setLessonDrawer = param.setLessonDrawer, me = param.me, courseType = param.courseType;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var trackEventsOnSegment = (0,useDPPEvents/* default */.Z)();
    var isEducatorSide = (0,useEducatorContext/* default */.Z)();
    var ref2 = lesson.liveClassDetails || {}, educatorSlides = ref2.drive_details, learnerNotes = ref2.learner_notes, practiceQuiz = ref2.practice_quiz;
    var meUID = me.uid, isModerator = me.isModerator, isEducator = me.isEducator;
    var author = lesson.author;
    var authorUID = author.uid;
    var isRecordedClass = (0,Item/* isRecordedSession */.m$)({
        courseType: courseType,
        classType: lesson.classType
    });
    var isLesssonLive = Item/* default.isLessonLive */.ZP.isLessonLive(lesson, 3600 * 1000);
    var isLessonUpcoming = Item/* default.isUpcoming */.ZP.isUpcoming(lesson);
    var showEditClassMenu = !isRecordedClass && !isLesssonLive && meUID === authorUID;
    var showDPPButton = !isRecordedClass && !isLesssonLive && ((ref = lesson.practiceDpp) === null || ref === void 0 ? void 0 : ref.cta) && meUID === authorUID;
    var showCreateQuizButton = !isRecordedClass && !isLesssonLive && isLessonUpcoming && meUID === authorUID;
    var onLessonClick = function() {
        if (isRecordedClass || lesson.state === constants/* sessionStates.FUTURE */.A_.FUTURE || !isModerator && authorUID !== meUID) return;
        onItemClick(lesson);
        Promise.all([
            dispatch((0,educator/* getLessonMetrics */.SoD)(lesson.uid, lesson.type)),
            dispatch((0,educator/* fetchLessonFeedback */.RTu)(lesson.uid, lesson.type))
        ]);
        if (lesson.type === "quiz") dispatch((0,quizTaking/* fetchQuizLeaderBoard */.$E)({
            quizUID: lesson.uid,
            isLive: lesson.isLive,
            nextPage: false
        }));
        setLessonDrawer(true);
    };
    var handleMenuClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget, lesson);
    };
    var infoString = Item/* default.getInfoString */.ZP.getInfoString(lesson, isTestSeries, true, false, isEducatorSide, true, true, courseType);
    var totalWatchTime = lesson.totalWatchTime, likePercentage = lesson.likePercentage, lessonType = lesson.type;
    var practiceDppStatistics = lesson === null || lesson === void 0 ? void 0 : (ref1 = lesson.practiceDpp) === null || ref1 === void 0 ? void 0 : ref1.statistics;
    if (totalWatchTime) totalWatchTime = (0,textHelper/* commas */.q1)(Math.floor(totalWatchTime / 60));
    var isLessonQuiz = true;
    if (lessonType === "post") isLessonQuiz = false;
    var isDPPNotAvailable = !(lesson === null || lesson === void 0 ? void 0 : lesson.practiceDpp);
    var routeToDpp = function(event) {
        var uid = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : lesson === null || lesson === void 0 ? void 0 : lesson.uid;
        event.stopPropagation();
        if (uid) {
            window.open("/educator/auto-dpp/".concat(uid));
        }
    };
    var onAutoDppButtonClick = function(event) {
        var ref, ref1;
        if (((ref = lesson.practiceDpp) === null || ref === void 0 ? void 0 : ref.cta) === "Add Practice") {
            var ref2, ref3;
            trackEventsOnSegment(segment/* EDUCATOR_PRACTICE_ADD_PRACTICE_CLICKED */.oeX, {
                last_primary_source: segment/* EDUCATOR_COURSE_PAGE */.nyB,
                goal_name: (ref2 = lesson === null || lesson === void 0 ? void 0 : lesson.goalName) !== null && ref2 !== void 0 ? ref2 : "NA",
                goal_uid: (ref3 = lesson === null || lesson === void 0 ? void 0 : lesson.goalUid) !== null && ref3 !== void 0 ? ref3 : "NA"
            });
        }
        if (((ref1 = lesson.practiceDpp) === null || ref1 === void 0 ? void 0 : ref1.cta) === "Review Draft") {
            var ref4, ref5;
            trackEventsOnSegment(segment/* EDUCATOR_PRACTICE_REVIEW_DRAFT_CLICKED */.kHr, {
                last_primary_source: segment/* EDUCATOR_COURSE_PAGE */.nyB,
                goal_name: (ref4 = lesson === null || lesson === void 0 ? void 0 : lesson.goalName) !== null && ref4 !== void 0 ? ref4 : "NA",
                goal_uid: (ref5 = lesson === null || lesson === void 0 ? void 0 : lesson.goalUid) !== null && ref5 !== void 0 ? ref5 : "NA"
            });
        }
        return routeToDpp(event, lesson === null || lesson === void 0 ? void 0 : lesson.uid);
    };
    var isStatisticsShown = function() {
        var ref;
        if (isRecordedClass) return false;
        return !isLessonQuiz && !isLessonUpcoming && !isLesssonLive || (lesson === null || lesson === void 0 ? void 0 : (ref = lesson.practiceDpp) === null || ref === void 0 ? void 0 : ref.statistics);
    };
    var getPracticeAttemptsWithComma = function() {
        if (practiceDppStatistics.practice_attempts) {
            return (0,textHelper/* commas */.q1)(practiceDppStatistics.practice_attempts);
        }
        return 0;
    };
    var getAccuracy = function() {
        if (practiceDppStatistics.accuracy) {
            return Math.round(practiceDppStatistics.accuracy);
        }
        return 0;
    };
    var ref3 = (0,toggleables/* useToggleable */.F7)(constants/* DRAWER_IDS.COURSE_CLASS_PLAYER */.UV.COURSE_CLASS_PLAYER), openDrawer = ref3.openElement;
    var isMyLessonLive = isLesssonLive && (me === null || me === void 0 ? void 0 : me.uid) === lesson.author.uid;
    var getAutoDppStatistics = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Statistics/* default */.Z, {
                    data: {
                        code: "PRACTICE_ATTEMPTS",
                        value: getPracticeAttemptsWithComma()
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Statistics/* default */.Z, {
                    data: {
                        code: "ACCURACY",
                        value: "".concat(getAccuracy(), "%")
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        onClick: onLessonClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ClassItemWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon/* default */.Z, {
                                lesson: lesson
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemInfo, {
                                id: lesson.uid,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6/* default */.Z, {
                                        children: lesson.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseInfo, {
                                        color: "var(--color-text-secondary)",
                                        children: infoString
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex, {
                        children: [
                            !isRecordedClass && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatsDiv, {
                                children: isMyLessonLive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    label: "Go live",
                                    color: "red",
                                    grid: 3,
                                    onClick: liveButtonClick(lesson.uid, openDrawer),
                                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Play/* default */.Z, {
                                        size: styleConstants/* Spacings.SPACING_4B */.t8.BM,
                                        color: "var(--color-base-1)"
                                    })
                                })
                            }),
                            showCreateQuizButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusButton/* default */.Z, {
                                sourceURL: router.asPath,
                                isTestSeries: isTestSeries,
                                contentType: lesson.creationType,
                                contentState: lesson.contentState,
                                sessionUID: lesson.uid
                            }),
                            showDPPButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutoDppButton, {
                                color: "black",
                                label: lesson.practiceDpp.cta,
                                width: "144px",
                                maxHeight: "sm",
                                onClick: onAutoDppButtonClick
                            }),
                            showEditClassMenu && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuWrapper, {
                                onClick: handleMenuClick,
                                className: "menuButton",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreVert/* default */.Z, {
                                        size: "22px",
                                        color: "var(--color-text-primary)"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isStatisticsShown() && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AutoDppStatsWrapper, {
                children: [
                    !isLessonQuiz && !isLessonUpcoming && !isLesssonLive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Statistics/* default */.Z, {
                                data: {
                                    code: "MINS",
                                    value: "".concat(totalWatchTime || 0)
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Statistics/* default */.Z, {
                                data: {
                                    code: "LIKED",
                                    value: "".concat(likePercentage || 0, "%")
                                }
                            })
                        ]
                    }),
                    practiceDppStatistics && getAutoDppStatistics()
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassMeta, {
                isEducator: isEducator,
                learnerNotes: learnerNotes,
                educatorSlides: educatorSlides,
                quizUID: isDPPNotAvailable && (practiceQuiz === null || practiceQuiz === void 0 ? void 0 : practiceQuiz.uid),
                canView: true,
                index: 0,
                goalUID: lesson.goalUid,
                topicGroups: (0,textHelper/* getCommaSeparatedUIDs */.$V)(lesson.topicGroups)
            })
        ]
    });
};
/* harmony default export */ var CourseDetails_ItemCard = (ItemCard);
ItemCard.propTypes = {
    lesson: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    onItemClick: (prop_types_default()).func.isRequired,
    isTestSeries: (prop_types_default()).bool,
    setAnchorEl: (prop_types_default()).func.isRequired,
    setLessonDrawer: (prop_types_default()).func.isRequired,
    me: prop_types_default().objectOf((prop_types_default()).any),
    courseType: (prop_types_default()).number
};
ItemCard.defaultProps = {
    isTestSeries: false,
    courseType: 1,
    me: {}
};

// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/hooks/useAllTypesOfCourseEventProps.js
var useAllTypesOfCourseEventProps = __webpack_require__(96780);
// EXTERNAL MODULE: ./src/stores/snackbar.js
var snackbar = __webpack_require__(97296);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/utils/segment/propsHelper.js
var propsHelper = __webpack_require__(9233);
// EXTERNAL MODULE: ./src/redux/selectors/auth.js
var auth = __webpack_require__(34497);
// EXTERNAL MODULE: ./src/components/Icons/EarlyMorning.jsx
var EarlyMorning = __webpack_require__(29327);
// EXTERNAL MODULE: ./src/components/Icons/Morning.jsx
var Morning = __webpack_require__(55951);
// EXTERNAL MODULE: ./src/components/Icons/Afternoon.jsx
var Afternoon = __webpack_require__(49250);
// EXTERNAL MODULE: ./src/components/Icons/Evening.jsx
var Evening = __webpack_require__(30693);
// EXTERNAL MODULE: ./src/components/Icons/LateEvening.jsx
var LateEvening = __webpack_require__(66741);
// EXTERNAL MODULE: ./src/components/Icons/Clock.jsx
var Clock = __webpack_require__(12656);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Icons/Icon.jsx
var Icon = __webpack_require__(55447);
;// CONCATENATED MODULE: ./src/components/Icons/PlayRectangle.jsx







var StyledIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Icon/* default */.Z, {
    target: "e15367av0",
    label: "StyledIcon"
})("fill:none;");
var PlayRectangle = function(props) {
    var color = props.color, rest = (0,_object_without_properties/* default */.Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 16 16"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12.6667 13H3.33333C2.6 13 2 12.4 2 11.6667V4.33333C2 3.59667 2.59667 3 3.33333 3H12.6667C13.4 3 14 3.6 14 4.33333V11.6667C14 12.4033 13.4033 13 12.6667 13Z",
                stroke: color,
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M7.338 6.06615L9.76401 7.50082C10.0707 7.68215 10.0707 8.12615 9.76401 8.30749L7.338 9.74215C7.02534 9.92682 6.63 9.70149 6.63 9.33882V6.46949C6.63067 6.10682 7.026 5.88149 7.338 6.06615V6.06615Z",
                stroke: color,
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    })));
};
PlayRectangle.propTypes = {
    color: (prop_types_default()).string
};
PlayRectangle.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ var Icons_PlayRectangle = (PlayRectangle);

// EXTERNAL MODULE: ./src/hooks/usePlatformBatchEventProps.js
var usePlatformBatchEventProps = __webpack_require__(60722);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/components/Base/H5/H5.jsx
var H5 = __webpack_require__(43807);
;// CONCATENATED MODULE: ./src/components/Icons/MockTest.jsx






var MockTest_StyledIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Icon/* default */.Z, {
    target: "e1093gnm0",
    label: "StyledIcon"
})("fill:none;");
var MockTest = function(props) {
    var color = props.color, fill = props.fill, rest = (0,_object_without_properties/* default */.Z)(props, [
        "color",
        "fill"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MockTest_StyledIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 16 16"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 14H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.5",
                stroke: "#7A8B94",
                strokeWidth: 1.22,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                clipRule: "evenodd",
                d: "M9.755 13.808A.655.655 0 0 1 9.29 14h-1.32v-1.32c0-.174.069-.341.192-.464l3.882-3.886a1.128 1.128 0 0 1 1.595 0v0a1.127 1.127 0 0 1 0 1.596l-3.885 3.882Z",
                stroke: "#7A8B94",
                strokeWidth: 1.199,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "m13.323 10.244.59.59c.31.31.31.814 0 1.125l-.714.715",
                stroke: "#7A8B94",
                strokeWidth: 1.199,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 8.334h2.5M5 6h6",
                stroke: "#7A8B94",
                strokeWidth: 1.22,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    })));
};
/* harmony default export */ var Icons_MockTest = (MockTest);

;// CONCATENATED MODULE: ./src/components/Icons/CalenderClock.jsx






var CalenderClock_StyledIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Icon/* default */.Z, {
    target: "e1r08mh90",
    label: "StyledIcon"
})("fill:none;");
var CalenderClock = function(props) {
    var color = props.color, fill = props.fill, rest = (0,_object_without_properties/* default */.Z)(props, [
        "color",
        "fill"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CalenderClock_StyledIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 16 16"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 12.25,
                r: 2.75,
                stroke: "#7A8B94",
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M11.934 11.323v1.072l.844.515",
                stroke: "#7A8B94",
                strokeWidth: 0.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M11.001 2.334v1.5M5 2.334v1.5M1.998 6.836h12.005M14 7.744V5.418c0-1.334-1.007-2.415-2.25-2.415h-7.5C3.007 3.003 2 4.084 2 5.418v6.17c0 1.334 1.007 2.415 2.25 2.415h3.083",
                stroke: "#7A8B94",
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    })));
};
/* harmony default export */ var Icons_CalenderClock = (CalenderClock);

// EXTERNAL MODULE: ./src/components/Container/Course/ItemCard.jsx + 3 modules
var Course_ItemCard = __webpack_require__(77003);
;// CONCATENATED MODULE: ./src/components/Container/Course/Week.jsx



/* eslint-disable max-lines */ 




































var classTimeIconMap = {
    1: EarlyMorning/* default */.Z,
    2: Morning/* default */.Z,
    3: Afternoon/* default */.Z,
    4: Evening/* default */.Z,
    5: LateEvening/* default */.Z,
    6: Clock/* default */.Z,
    7: Clock/* default */.Z,
    20: Clock/* default */.Z
};
var WeekInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e1gu67tl0",
    label: "WeekInfo"
})("margin-top:", styleConstants/* Spacings.SPACING_6 */.t8.A1, ";color:var(--color-text-primary);", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{color:var(--color-text-secondary);}");
var CountInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1gu67tl1",
    label: "CountInfo"
})("color:var(--color-text-secondary);");
var CountWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1gu67tl2",
    label: "CountWrapper"
})("margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var WeekInfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1gu67tl3",
    label: "WeekInfoWrapper"
})("grid-column:2/9;position:sticky;top:235px;opacity:", function(param) {
    var isEducatorSide = param.isEducatorSide, notAccessible = param.notAccessible;
    return isEducatorSide ? 1 : notAccessible && 0.5;
}, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{top:48px;background-color:var(--color-base-0);width:100%;padding-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";padding-bottom:", function(param) {
    var $isStats = param.$isStats;
    return $isStats ? styleConstants/* Spacings.SPACING_0B */.t8.NE : styleConstants/* Spacings.SPACING_4B */.t8.BM;
}, ";z-index:1;opacity:1;grid-column:span 10;margin-bottom:8px;}");
var Week_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1gu67tl4",
    label: "Wrapper"
})("display:grid;grid-template-columns:repeat(24,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";grid-column:span 24;margin-top:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";position:relative;margin-bottom:", function(param) {
    var isBatch = param.isBatch;
    return isBatch ? 0 : styleConstants/* Spacings.SPACING_13B */.t8.zw;
}, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:block;margin-bottom:0px;grid-column:span 10;grid-template-columns:repeat(10,1fr);margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}");
var SeeAll = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e1gu67tl5",
    label: "SeeAll"
})("grid-column:9/25;background-color:var(--color-base-1);height:70px;text-align:center;cursor:pointer;padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";color:var(--color-text-primary);", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{grid-column:span 10;height:56px;padding:18px 0;font-size:14px;}");
var Description = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1gu67tl6",
    label: "Description"
})("color:var(--color-text-secondary);margin-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}");
var InfoRow = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1gu67tl7",
    label: "InfoRow"
})("display:flex;margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";align-items:center;");
var IconWrap = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1gu67tl8",
    label: "IconWrap"
})("margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";width:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";height:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyledP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1gu67tl9",
    label: "StyledP1"
})("color:var(--color-text-secondary);", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{font-size:", styleConstants/* Fonts.P2 */.F3.P2, ";line-height:", styleConstants/* Spacings.SPACING_5B */.t8.zj, ";}");
var Week = function(param) {
    var goalUID = param.goalUID, lessonList = param.lessonList, onItemClick = param.onItemClick, weekTitle = param.weekTitle, weekInfo = param.weekInfo, weekPlusInfoData = param.weekPlusInfoData, showEducatorForLesson = param.showEducatorForLesson, isTestSeries = param.isTestSeries, isSubscribed = param.isSubscribed, forPlus = param.forPlus, cardPosition = param.cardPosition, subscription = param.subscription, setAnchorEl = param.setAnchorEl, showActionMenu = param.showActionMenu, setLessonDrawer = param.setLessonDrawer, isBatch = param.isBatch, batch = param.batch, renewalData = param.renewalData, showMoreMenu = param.showMoreMenu, lastPrimarySourceSection = param.lastPrimarySourceSection, isBatchGroup = param.isBatchGroup, showLiveBatch = param.showLiveBatch, courseType = param.courseType, accessEndDate = param.accessEndDate, hasDppAccess = param.hasDppAccess, isOnlyRecordedClassesPresent = param.isOnlyRecordedClassesPresent;
    var ref;
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var me = (0,es/* useSelector */.v9)(auth/* getMe */.jo);
    var retreivedGoalUID = goalUID || (batch === null || batch === void 0 ? void 0 : (ref = batch.goal) === null || ref === void 0 ? void 0 : ref.uid);
    if (!retreivedGoalUID) retreivedGoalUID = (lessonList === null || lessonList === void 0 ? void 0 : lessonList.length) ? lessonList[0].goalUid : null;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: retreivedGoalUID
    });
    var segmentData = (0,useAllTypesOfCourseEventProps/* default */.Z)({
        course: batch,
        isBatch: true
    });
    var platformsSegmentData = (0,usePlatformBatchEventProps/* default */.Z)({
        batch: batch,
        isBatch: true,
        lastPrimarySourceSection: lastPrimarySourceSection,
        lastPrimarySource: lastPrimarySourceSection
    });
    var ref1 = batch || {}, timeType = ref1.timeType, _lessonsCount = ref1.lessonsCount, lessonsCount = _lessonsCount === void 0 ? 0 : _lessonsCount, _quizzesCount = ref1.quizzesCount, quizzesCount = _quizzesCount === void 0 ? 0 : _quizzesCount, _testSeries = ref1.testSeries, testSeries = _testSeries === void 0 ? 0 : _testSeries, _classFrequencyType = ref1.classFrequencyType, classFrequencyType = _classFrequencyType === void 0 ? "" : _classFrequencyType, _mockTestFrequencyType = ref1.mockTestFrequencyType, mockTestFrequencyType = _mockTestFrequencyType === void 0 ? "" : _mockTestFrequencyType;
    var typeOfClassTime = timeType === null || timeType === void 0 ? void 0 : timeType.type;
    var ClassTimeType = typeOfClassTime && classTimeIconMap[typeOfClassTime];
    var isEducatorSide = (0,useEducatorContext/* default */.Z)();
    var ref2 = (0,snackbar/* useSnackbar */.Ds)(), showSnackbar = ref2.open;
    var handleClick = function() {
        if (isBatchGroup) {
            analytics/* segment.track */.EX.track(segment/* PLATFORM_BATCH_SCHEDULE */.bje, (0,_object_spread/* default */.Z)({}, segmentData, platformsSegmentData));
        }
        if (isBatch) {
            analytics/* segment.track */.EX.track(segment/* BATCH_SCHEDULE */.krA, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData, segmentData), {
                batch_state: batch.state,
                is_store_exclusive: batch === null || batch === void 0 ? void 0 : batch.isStoreExclusive
            }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, segment/* BATCH_KEYS */.A8$);
        }
        if (isBatchGroup) {
            (0,pushRoute/* default */.Z)("/batch/[slug]/[batchUID]/schedule?associated_batch=".concat(batch.batchUID), "/batch/".concat(batch.slug, "/").concat(batch.uid, "/schedule?associated_batch=").concat(batch.batchUID));
        } else {
            (0,pushRoute/* default */.Z)("/batch/[slug]/[batchUID]/schedule", "/batch/".concat(batch.slug, "/").concat(batch.uid, "/schedule"));
        }
    };
    var ref3 = (0,react.useState)(false), isUnEnrollModalOpen = ref3[0], setIsUnEnrollModalOpen = ref3[1];
    var selectedLesson = (0,react.useRef)();
    var showRemoveDialog = function(lesson) {
        selectedLesson.current = lesson;
        setIsUnEnrollModalOpen(true);
    };
    var onCloseModal = function() {
        setIsUnEnrollModalOpen(false);
        selectedLesson.current = null;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var removeFromCollection = function() {
        var lesson = selectedLesson.current;
        if (lesson) {
            var ref;
            var goalUid = ((ref = lesson.goal) === null || ref === void 0 ? void 0 : ref.uid) || lesson.goalUid;
            var isLesson = (0,Item/* isPost */.f5)(lesson);
            var entityType = isLesson ? constants/* savedObjectTypes.LESSON */.cc.LESSON : constants/* savedObjectTypes.TEST */.cc.TEST;
            dispatch((0,saved/* removeEntityFromSaved */.YG)({
                goalUid: goalUid,
                objectUid: lesson.uid,
                entityType: entityType,
                key: "".concat(goalUid, "-").concat(isLesson ? "lessons" : "tests")
            })).then(function() {
                showSnackbar({
                    message: "".concat(isLesson ? "Lesson" : "Test", " removed successfully"),
                    type: "success"
                });
                analytics/* segment.track */.EX.track(segment/* SAVE_UNSAVE_CONTENT */.AvE, (0,_object_spread/* default */.Z)({
                    save_content_type: (0,propsHelper/* getSavedContentType */.D)(entityType),
                    save_content_uid: lesson.uid,
                    save_content_title: lesson.name
                }, goalSegmentData));
            });
        }
        onCloseModal();
    };
    var getLiveClassText = function() {
        var str = "";
        var testCount = quizzesCount + testSeries;
        var testText = testCount ? (0,textHelper/* pluralize */._6)(testCount, "test") : "";
        if (lessonsCount) str += "".concat(lessonsCount, "+ live classes");
        if (str && testText) str += " \u2022 ";
        str += testText;
        if (str) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons_PlayRectangle, {
                            size: "16px",
                            "aria-hidden": "true",
                            color: "var(--color-text-secondary)"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                        children: str
                    })
                ]
            });
        }
    };
    var getMockTestText = function() {
        return mockTestFrequencyType ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons_MockTest, {
                        size: "16px",
                        "aria-hidden": "true",
                        color: "var(--color-text-secondary)"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                    children: "Mock tests \u2022 ".concat(classFrequencyType)
                })
            ]
        }) : null;
    };
    var getAccessText = function() {
        return accessEndDate ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons_CalenderClock, {
                        size: "16px",
                        "aria-hidden": "true",
                        color: "var(--color-text-secondary)"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                    children: "Access ends on ".concat(accessEndDate)
                })
            ]
        }) : null;
    };
    var getScheduleStats = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Description, {
            children: [
                typeOfClassTime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassTimeType, {
                                size: "16px",
                                "aria-hidden": "true",
                                color: "var(--color-text-secondary)"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                            children: "".concat(timeType.text, " ").concat(classFrequencyType ? "\u2022 ".concat(classFrequencyType) : "")
                        })
                    ]
                }),
                getMockTestText(),
                getAccessText(),
                !isBatch && getLiveClassText()
            ]
        });
    };
    var renderWeekInfo = function() {
        if (weekPlusInfoData && forPlus) {
            var dateInfo = weekPlusInfoData.dateInfo, lessonCountInfo = weekPlusInfoData.lessonCountInfo, dppCount = weekPlusInfoData.dppCount;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H5/* default */.Z, {
                        children: dateInfo
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CountWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountInfo, {
                                children: lessonCountInfo
                            }),
                            dppCount > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountInfo, {
                                children: (0,textHelper/* pluralize */._6)(dppCount, "practice")
                            }) : null
                        ]
                    })
                ]
            });
        }
        if (weekInfo) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WeekInfo, {
                color: "var(--color-text-secondary)",
                as: "h5",
                children: weekInfo
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Week_Wrapper, {
        isBatch: isBatch,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WeekInfoWrapper, {
                id: weekTitle,
                notAccessible: cardPosition !== -1 && cardPosition <= (lessonList === null || lessonList === void 0 ? void 0 : lessonList[0].rank),
                isEducatorSide: isEducatorSide,
                $isStats: typeOfClassTime,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H4/* default */.Z, {
                        color: "var(--color-text-primary)",
                        children: weekTitle
                    }),
                    renderWeekInfo(),
                    !isMobile && getScheduleStats()
                ]
            }),
            isMobile && getScheduleStats(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog["default"], {
                onClose: onCloseModal,
                dialogState: isUnEnrollModalOpen,
                heading: "Remove from Saved?",
                message: "This will remove the ".concat((0,Item/* isPost */.f5)(selectedLesson.current) ? "lesson" : "test", " from your saved list. You can add it back from the ").concat((0,Item/* isPost */.f5)(selectedLesson.current) ? "course" : "test series", " page."),
                messageWidth: "82.5%",
                acceptLabel: "Remove",
                rejectLabel: "Cancel",
                acceptOnClick: removeFromCollection,
                rejectOnClick: onCloseModal
            }),
            lessonList === null || lessonList === void 0 ? void 0 : lessonList.map(function(lesson) {
                if (!isEducatorSide) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_ItemCard/* default */.Z, {
                        lesson: lesson,
                        onItemClick: onItemClick,
                        showEducatorForLesson: showEducatorForLesson,
                        isTestSeries: isTestSeries,
                        isSubscribed: isSubscribed,
                        forPlus: forPlus,
                        courseType: courseType,
                        batchType: batch === null || batch === void 0 ? void 0 : batch.batchType,
                        cardPosition: cardPosition,
                        subscription: subscription,
                        setPdfAnchorEl: setAnchorEl,
                        setAnchorEl: showActionMenu,
                        isBatch: isBatch,
                        showMoreMenu: showMoreMenu,
                        renewalData: renewalData,
                        showRemoveDialog: showRemoveDialog,
                        goalUID: goalUID,
                        isBatchGroup: isBatchGroup,
                        showLiveBatch: showLiveBatch,
                        hasDppAccess: hasDppAccess,
                        isOnlyRecordedClassesPresent: isOnlyRecordedClassesPresent
                    }, lesson.uid);
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseDetails_ItemCard, {
                    courseType: courseType,
                    lesson: lesson,
                    onItemClick: onItemClick,
                    isTestSeries: isTestSeries,
                    setAnchorEl: setAnchorEl,
                    setLessonDrawer: setLessonDrawer,
                    me: me
                }, lesson.uid);
            }),
            isBatch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeAll, {
                onClick: handleClick,
                children: "View complete schedule"
            })
        ]
    });
};
/* harmony default export */ var Course_Week = (Week);
var doNothing = function() {};
Week.propTypes = {
    lessonList: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    onItemClick: (prop_types_default()).func.isRequired,
    weekTitle: (prop_types_default()).string.isRequired,
    weekInfo: (prop_types_default()).string.isRequired,
    showEducatorForLesson: (prop_types_default()).bool,
    isTestSeries: (prop_types_default()).bool,
    isSubscribed: (prop_types_default()).bool,
    forPlus: (prop_types_default()).bool,
    cardPosition: (prop_types_default()).number,
    setAnchorEl: (prop_types_default()).func,
    showActionMenu: (prop_types_default()).func,
    setLessonDrawer: (prop_types_default()).func,
    isBatch: (prop_types_default()).bool,
    batch: prop_types_default().objectOf((prop_types_default()).any),
    subscription: prop_types_default().objectOf((prop_types_default()).any),
    renewalData: prop_types_default().objectOf((prop_types_default()).any),
    showMoreMenu: (prop_types_default()).bool,
    goalUID: (prop_types_default()).string,
    isBatchGroup: (prop_types_default()).bool,
    showLiveBatch: (prop_types_default()).bool
};
Week.defaultProps = {
    showEducatorForLesson: false,
    isTestSeries: false,
    isSubscribed: false,
    forPlus: false,
    isBatch: false,
    cardPosition: -1,
    batch: null,
    subscription: {},
    renewalData: {},
    setLessonDrawer: doNothing,
    setAnchorEl: doNothing,
    showActionMenu: doNothing,
    showMoreMenu: false,
    goalUID: "",
    isBatchGroup: false,
    showLiveBatch: false
};


/***/ }),

/***/ 1834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80867);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38364);





var StatisticsWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1pujpz10",
    label: "StatisticsWrapper"
})("display:flex;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_7B */ .t8.d5, ";");
var StatisticsText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1pujpz11",
    label: "StatisticsText"
})("font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.ULTRA_SMALL */ .F3.tN, ";margin:auto;color:var(--color-i-gray);margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var Statistics = function(param) {
    var data = param.data;
    var stats = _constants__WEBPACK_IMPORTED_MODULE_3__/* .DPP_STATS_MAP */ .Pn === null || _constants__WEBPACK_IMPORTED_MODULE_3__/* .DPP_STATS_MAP */ .Pn === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_3__/* .DPP_STATS_MAP */ .Pn[data === null || data === void 0 ? void 0 : data.code];
    if (!stats) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(StatisticsWrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                width: 24,
                height: 24,
                alt: "statistics-icon",
                src: stats.icon
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(StatisticsText, {
                children: [
                    data === null || data === void 0 ? void 0 : data.value,
                    " ",
                    stats.text
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Statistics);


/***/ }),

/***/ 34958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87936);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59375);
/* harmony import */ var _educator_Onboard_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98220);
/* harmony import */ var _hooks_reduxHooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88738);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34497);






var useDPPEvents = function() {
    var educator = (0,_hooks_reduxHooks__WEBPACK_IMPORTED_MODULE_3__/* .useSelectorWithShallowEqual */ .hM)(_selectors_auth__WEBPACK_IMPORTED_MODULE_4__/* .getMe */ .jo);
    var ref = educator || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD, username = ref.username, isPlusEducator = ref.isPlusEducator, uid = ref.uid, userID = ref.userID, isActive = ref.isActive, kycDetails = ref.kycDetails;
    var onboarding = (0,_hooks_reduxHooks__WEBPACK_IMPORTED_MODULE_3__/* .useSelectorWithShallowEqual */ .hM)(function(param) {
        var educatorOnboarding = param.educatorOnboarding;
        return educatorOnboarding;
    });
    return function(actionKey) {
        var additionalProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _actions_analytics__WEBPACK_IMPORTED_MODULE_0__/* .segment.track */ .EX.track(actionKey, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            educator_username: username !== null && username !== void 0 ? username : "NA",
            educator_type: isPlusEducator ? "Plus Educator" : "Educator",
            educator_uid: uid !== null && uid !== void 0 ? uid : "NA",
            educator_id: userID !== null && userID !== void 0 ? userID : "NA",
            educator_status: isActive ? "Active" : "Inactive",
            is_kyc_done: (kycDetails === null || kycDetails === void 0 ? void 0 : kycDetails.state) === _educator_Onboard_constants__WEBPACK_IMPORTED_MODULE_2__/* .KYCState.VERIFIED */ .qH.VERIFIED || (onboarding === null || onboarding === void 0 ? void 0 : onboarding.onboardingState) === _educator_Onboard_constants__WEBPACK_IMPORTED_MODULE_2__/* .OnboardingFlow.KYC_DONE */ .XX.KYC_DONE
        }, additionalProps));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDPPEvents);


/***/ }),

/***/ 1682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2080);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10076);
/* harmony import */ var _base_H7_H7__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28197);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52420);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43135);
/* harmony import */ var _comp_FileUpload_Iframe__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90347);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _actions_templates__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50985);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48821);













var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1wq6dxn0",
    label: "Wrapper"
})("border-top:1px dashed var(--color-divider);margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_6B */ .t8.BY, ";padding-top:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_6B */ .t8.BY, ";display:flex;& >:not(:last-child){margin-right:", function(param) {
    var $isEducator = param.$isEducator;
    return $isEducator ? "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_13B */ .t8.zw) : "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_27B */ .t8.yz);
}, ";}& >:last-child{margin-right:", function(param) {
    var $isEducator = param.$isEducator;
    return $isEducator ? "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_12B */ .t8.SL) : 0;
}, ";}");
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1wq6dxn1",
    label: "Flex"
})("display:flex;");
var UnderlineButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H7_H7__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e1wq6dxn2",
    label: "UnderlineButton"
})("width:fit-content;cursor:pointer;border-bottom:1px dashed var(--color-divider);line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Fonts.BUTTON_LINE_HEIGHT */ .F3.UH, ";padding-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_1B */ .t8.MK, ";margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var Image = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1wq6dxn3",
    label: "Image"
})("background-color:", function(param) {
    var $bgColor = param.$bgColor;
    return $bgColor;
}, ";background-image:", function(param) {
    var $bgImage = param.$bgImage;
    return "url(".concat($bgImage, ")");
}, ";height:48px;width:48px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_4B */ .t8.BM, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_6 */ .t8.A1, ";background-repeat:no-repeat;background-position:center;background-size:22px;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_3B */ .t8.N, ";");
var getQuizStateInfo = function(contentState, sessionUID, source) {
    if (!sessionUID) return {};
    switch(contentState){
        case _constants_index__WEBPACK_IMPORTED_MODULE_5__/* .QUIZ_CONTENT_STATE.QUESTION_COMPLETED */ .Ah.QUESTION_COMPLETED:
            return {
                label: "VIEW QUESTIONS",
                url: "/educator/test/review/".concat(sessionUID, "/?exitFrom=top&source=").concat(source)
            };
        default:
            return {
                label: "ADD QUESTIONS",
                url: "/educator/test/edit/".concat(sessionUID, "?source=").concat(source)
            };
    }
};
var ClassMetaData = function(param) {
    var learnerNotes = param.learnerNotes, educatorSlides = param.educatorSlides, quizUID = param.quizUID, canView = param.canView, goalUID = param.goalUID, topicGroups = param.topicGroups, isEducator = param.isEducator, className = param.className;
    var quizState = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(param) {
        var templates = param.templates;
        return templates.addEditTemplate.quizStates[quizUID];
    });
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), driveMode = ref[0], setDriveMode = ref[1];
    var action = getQuizStateInfo(quizState, quizUID, router.asPath);
    if (canView) action = {
        label: "VIEW QUESTIONS",
        url: "/educator/test/review/".concat(quizUID, "/?exitFrom=top&source=").concat(router.asPath)
    };
    var finishEditing = function(id, data) {
        return dispatch((0,_actions_templates__WEBPACK_IMPORTED_MODULE_9__/* .updateEducatorSlides */ .fF)(data, educatorSlides.uid));
    };
    var handleEducatorSlides = function() {
        if (canView) setDriveMode("view");
        else setDriveMode("edit");
    };
    var slides = Array.isArray(educatorSlides) ? educatorSlides[0] : educatorSlides;
    if (!(slides === null || slides === void 0 ? void 0 : slides.uid) && !(learnerNotes === null || learnerNotes === void 0 ? void 0 : learnerNotes.url) && !quizUID) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Wrapper, {
        $isEducator: isEducator,
        className: className,
        children: [
            (slides === null || slides === void 0 ? void 0 : slides.uid) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Flex, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Image, {
                        $bgColor: "var(--color-i-pink-2)",
                        $bgImage: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_10__/* .getImage */ .gJ)("pdf.svg"),
                        alt: "pdf download"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                children: "Educator slides"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(UnderlineButton, {
                                color: "var(--color-i-blue)",
                                onClick: handleEducatorSlides,
                                children: [
                                    canView ? "VIEW" : "OPEN EDITOR",
                                    [
                                        "view",
                                        "edit"
                                    ].includes(driveMode) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_comp_FileUpload_Iframe__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        id: "educatorSlides",
                                        mode: driveMode,
                                        setMode: setDriveMode,
                                        file: slides,
                                        finishUpload: finishEditing,
                                        goalUID: goalUID,
                                        topicGroups: topicGroups,
                                        isEducator: isEducator
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (learnerNotes === null || learnerNotes === void 0 ? void 0 : learnerNotes.url) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Flex, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Image, {
                        $bgColor: "var(--color-i-light-green)",
                        $bgImage: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_10__/* .getImage */ .gJ)("stats/lessons.svg"),
                        alt: "statistics lesson"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                children: "Learner notes"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(UnderlineButton, {
                                color: "var(--color-i-blue)",
                                onClick: function() {
                                    return window.open(learnerNotes.url, "_blank");
                                },
                                children: "VIEW"
                            })
                        ]
                    })
                ]
            }),
            quizUID && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Flex, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Image, {
                        $bgColor: "var(--color-i-orange-3)",
                        $bgImage: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_10__/* .getImage */ .gJ)("assignment.svg"),
                        alt: "assignment"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                children: "Practice"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(UnderlineButton, {
                                color: "var(--color-i-blue)",
                                onClick: function() {
                                    return window.open("".concat(window.location.origin).concat(action.url));
                                },
                                children: action.label
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClassMetaData);
ClassMetaData.propTypes = {
    learnerNotes: prop_types__WEBPACK_IMPORTED_MODULE_12___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_12___default().any)),
    educatorSlides: prop_types__WEBPACK_IMPORTED_MODULE_12___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_12___default().any)),
    quizUID: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    canView: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().bool),
    goalUID: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    topicGroups: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    isEducator: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string)
};
ClassMetaData.defaultProps = {
    quizUID: "",
    learnerNotes: {},
    educatorSlides: {},
    canView: false,
    goalUID: "",
    topicGroups: "",
    isEducator: false,
    className: ""
};


/***/ }),

/***/ 49250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "esanzu00",
    label: "StyledIcon"
})("fill:none;");
var Afternoon = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M12.946 7.054a4.167 4.167 0 1 1-5.893 5.892 4.167 4.167 0 0 1 5.893-5.892M10 3.333V1.667M10 18.333v-1.666M15.3 4.7l.592-.592M4.108 15.892L4.7 15.3M16.667 10h1.666M1.667 10h1.666M15.3 15.3l.592.592M4.108 4.108L4.7 4.7",
            stroke: color,
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    })));
};
Afternoon.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
Afternoon.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (Afternoon);


/***/ }),

/***/ 12656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "eh6qzis0",
    label: "StyledIcon"
})("fill:none;");
var Clock = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 16 16"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("circle", {
                cx: "8",
                cy: "8",
                r: "6.0025",
                stroke: color,
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                d: "M10.3036 8.76761L8 7.99996V3.99829",
                stroke: color,
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    })));
};
Clock.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
Clock.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (Clock);


/***/ }),

/***/ 83583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Download = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M40 7.5c-17.949 0-32.5 14.551-32.5 32.5s14.551 32.5 32.5 32.5c17.949 0 32.5-14.551 32.5-32.5v0c-0.019-17.942-14.558-32.481-32.498-32.5h-0.002zM40 67.5c-15.188 0-27.5-12.312-27.5-27.5s12.312-27.5 27.5-27.5c15.188 0 27.5 12.312 27.5 27.5v0c-0.019 15.18-12.32 27.481-27.498 27.5h-0.002zM45.8 41.7l-3.333 3.333v-16.067c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0 16.033l-3.333-3.333c-0.452-0.452-1.077-0.731-1.767-0.731s-1.314 0.279-1.767 0.731v0c-0.46 0.449-0.745 1.074-0.745 1.767s0.285 1.318 0.745 1.766l0.001 0 7.567 7.567c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0l7.567-7.567c0.46-0.449 0.745-1.074 0.745-1.767s-0.285-1.318-0.745-1.766l-0.001-0c-0.447-0.422-1.051-0.682-1.716-0.682-0.682 0-1.3 0.273-1.751 0.716l0-0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Download);


/***/ }),

/***/ 29327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1x63daw0",
    label: "StyledIcon"
})("fill:none;");
var EarlyMorning = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M7.083 9.583a2.917 2.917 0 0 1 5.834 0M15.833 9.167H17.5M2.5 9.167h1.667M10 3.333V1.667M14.125 5.042L15.3 3.867M4.7 3.867l1.175 1.175M2.5 12.5h8.333M14.167 12.5H17.5M16.667 15h-7.5M3.333 15h2.5",
            stroke: color,
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    })));
};
EarlyMorning.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
EarlyMorning.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (EarlyMorning);


/***/ }),

/***/ 30693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "efkbw4b0",
    label: "StyledIcon"
})("fill:none;");
var Evening = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M10 4.167V2.5M1.667 10.833h1.666M4.167 5L5 5.833M15.833 5L15 5.833M18.45 10.833h-1.783M10 16.667V12.5M8.333 15L10 16.667 11.667 15M6.667 10.833a3.333 3.333 0 0 1 6.666 0",
            stroke: color,
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    })));
};
Evening.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
Evening.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (Evening);


/***/ }),

/***/ 66741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1aw2uab0",
    label: "StyledIcon"
})("fill:none;");
var LateEvening = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.234 11.82a.416.416 0 0 1 .586.472 6.87 6.87 0 0 1-1.796 3.156 6.788 6.788 0 0 1-9.598.126 6.792 6.792 0 0 1 .126-9.602 6.862 6.862 0 0 1 3.139-1.791.424.424 0 0 1 .48.597 5.359 5.359 0 0 0 .992 6.057 5.354 5.354 0 0 0 6.07.985zM14.45 2.826a.627.627 0 0 1 1.1 0l.486.89a.625.625 0 0 0 .249.248l.889.486a.627.627 0 0 1 0 1.1l-.89.486a.625.625 0 0 0-.247.249l-.486.889a.627.627 0 0 1-1.101 0l-.486-.89a.625.625 0 0 0-.249-.248l-.889-.486a.627.627 0 0 1 0-1.1l.89-.486a.625.625 0 0 0 .248-.249l.486-.889z",
            stroke: color,
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    })));
};
LateEvening.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
LateEvening.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (LateEvening);


/***/ }),

/***/ 55951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1f1itui0",
    label: "StyledIcon"
})("fill:none;");
var Morning = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            d: "M10 4.167V2.5M1.667 10.833h1.666M4.167 5L5 5.833M15.833 5L15 5.833M18.45 10.833h-1.783M10 12.5v4.167M11.667 14.167L10 12.5l-1.667 1.667M6.667 10.833a3.333 3.333 0 0 1 6.666 0",
            stroke: color,
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    })));
};
Morning.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
Morning.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (Morning);


/***/ }),

/***/ 99102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Play = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M71.725 49.506l-49.679 27.642c-1.698 0.974-3.632 1.498-5.607 1.517-2.013-0-3.988-0.525-5.719-1.517-1.732-0.941-3.175-2.31-4.18-3.968s-1.536-3.543-1.54-5.464v-55.502c0.003-1.921 0.535-3.806 1.54-5.463s2.447-3.026 4.18-3.968c1.705-0.951 3.639-1.452 5.607-1.452s3.902 0.501 5.607 1.452l49.679 27.642c1.78 0.929 3.267 2.306 4.304 3.985s1.584 3.599 1.584 5.554-0.547 3.875-1.584 5.554c-1.036 1.68-2.524 3.056-4.304 3.985h0.112z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Play);


/***/ }),

/***/ 93496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);

/* eslint-disable no-else-return */ 



var StyledCarousel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "eq1k4de0",
    label: "StyledCarousel"
})("display:grid;grid-template-columns:repeat(18,32px);grid-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-column:span 18;@media only screen and (max-width:47.95em){grid-template-columns:repeat(10,1fr);grid-column:span 10;grid-column-gap:16px;grid-row-gap:16px;}");
var CourseCarousel = function(param) {
    var number = param.number, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledCarousel, {
        $number: number,
        children: children
    });
};
CourseCarousel.propTypes = {
    number: function number(props, propName, componentName) {
        if (typeof props[propName] !== "number") {
            return new Error("Invalid type of ".concat(propName, " supplied to ").concat(componentName, " Validation failed."));
        } else if (props[propName] > 3) {
            return new Error("Expected max value for ".concat(propName, " is 3 but supplied greater value to ").concat(componentName, " Validation failed."));
        }
    },
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired)
};
CourseCarousel.defaultProps = {
    number: 3
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCarousel);


/***/ }),

/***/ 10914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CourseCard_CourseCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Skeletons/Carousel/Carousel.jsx
var Carousel = __webpack_require__(93496);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/stores/selectors/darkModeStatusSelectors.js
var darkModeStatusSelectors = __webpack_require__(57054);
// EXTERNAL MODULE: ./src/stores/useDarkModeStatus.js
var useDarkModeStatus = __webpack_require__(3458);
;// CONCATENATED MODULE: ./src/components/Skeletons/CourseCard/CourseCard.jsx









var StyledPlusCourseCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wi5id40",
    label: "StyledPlusCourseCard"
})("background-color:var(--color-base-1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";overflow:hidden;grid-column:span 6;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){grid-column:span 11;}");
var StyledSkeleton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Skeleton/* default */.Z, {
    target: "e1wi5id41",
    label: "StyledSkeleton"
})("@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){&.thumbnail{width:100% !important;}}", function(param) {
    var $isDarkModeOn = param.$isDarkModeOn;
    return $isDarkModeOn && "background-color: var(--color-base-1);";
});
var StyledPlusCourseCardDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wi5id42",
    label: "StyledPlusCourseCardDetails"
})("display:flex;flex-direction:column;justify-content:space-between;background-color:var(--color-base-1);text-align:left;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var CourseCard = function(param) {
    var className = param.className;
    var isDarkModeOn = (0,useDarkModeStatus/* default */.Z)(darkModeStatusSelectors/* getIsDarkModeOn */.q1);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPlusCourseCard, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                variant: "rect",
                width: 272,
                height: 153,
                className: "thumbnail",
                $isDarkModeOn: isDarkModeOn
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPlusCourseCardDetails, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 22,
                        width: "20%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 20,
                        width: "100%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 20,
                        width: "30%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 12,
                        width: "70%",
                        style: {
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 18,
                        width: "40%"
                    })
                ]
            })
        ]
    });
};
CourseCard.propTypes = {
    className: (prop_types_default()).string
};
CourseCard.defaultProps = {
    className: ""
};
/* harmony default export */ var CourseCard_CourseCard = (CourseCard);

;// CONCATENATED MODULE: ./src/components/Skeletons/CourseCard/CourseCarousel.jsx




var CourseCarousel = function(param) {
    var number = param.number, gridColumn = param.gridColumn;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default */.Z, {
        number: number,
        gridColumn: gridColumn,
        children: new Array(number).fill(0).map(function(val, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCard_CourseCard, {}, String(index));
        })
    });
};
CourseCarousel.propTypes = {
    number: (prop_types_default()).number,
    gridColumn: (prop_types_default()).string
};
CourseCarousel.defaultProps = {
    number: 3,
    gridColumn: "span 18"
};
/* harmony default export */ var CourseCard_CourseCarousel = (CourseCarousel);


/***/ }),

/***/ 96780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31309);
/* harmony import */ var _models_Me__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92942);
/* harmony import */ var _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73995);
/* harmony import */ var _api_selectors_subscription__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58063);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85780);
/* harmony import */ var _cont_Batch_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73993);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);










var useAllTypesOfCourseEventProps = function(param) {
    var _course = param.course, course = _course === void 0 ? {} : _course, _isTestSeries = param.isTestSeries, isTestSeries = _isTestSeries === void 0 ? false : _isTestSeries, _isBatch = param.isBatch, isBatch = _isBatch === void 0 ? false : _isBatch;
    var plusSubscriptions = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_4__/* .getMePlusSubscriptions */ .IP);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var asPath = (router || {}).asPath;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref = course || {}, startsAt = ref.startsAt, endsAt = ref.endsAt, courseTitle = ref.name, courseUID = ref.uid, authors = ref.authors, courseType = ref.courseType, completedAt = ref.completedAt, isEnrolled = ref.isEnrolled, language = ref.language, goal = ref.goal, isStoreExclusive = ref.isStoreExclusive, educatorType = ref.educatorType, contentType = ref.contentType, additionalFeatures = ref.additionalFeatures, isSellable = ref.isSellable;
        var ref1 = goal || {}, goalUID = ref1.uid, goalName = ref1.name;
        var ref2;
        var ref3 = (ref2 = (0,_models_Me__WEBPACK_IMPORTED_MODULE_3__/* .getSubscription */ .pI)(plusSubscriptions, goalUID)) !== null && ref2 !== void 0 ? ref2 : {}, _time_remaining = ref3.time_remaining, time_remaining = _time_remaining === void 0 ? 0 : _time_remaining;
        var is_subscription_active = time_remaining > 0;
        var _obj;
        var segmentData = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .START_DATE */ .dB, startsAt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .END_DATE */ .I7, endsAt || completedAt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .EDUCATOR_UID */ .cY, (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_2__/* .getCommaSeparatedUIDs */ .$V)(authors)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .EDUCATOR_USERNAME */ .eq, (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_2__/* .getCommaSeparatedUIDs */ .$V)(authors, "username")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .IS_ENROLLED */ .ZX, isEnrolled || false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .LANGUAGE */ .ad, language || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_2__/* .getCommaSeparatedUIDs */ .$V)(language, "label")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .GOAL_NAME */ .nX, goalName), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .GOAL_UID */ .bi, goalUID), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .IS_SUBSCRIPTION_ACTIVE */ ._l, is_subscription_active), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .LAST_PRIMARY_SOURCE_SECTION */ .n$, "NA"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .IS_STORE_EXCLUSIVE */ .a, isStoreExclusive), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .EDUCATOR_TYPE */ .pY, educatorType === _cont_Batch_utils__WEBPACK_IMPORTED_MODULE_6__/* .EDUCATOR_TYPES.PARTNER */ .MB.PARTNER ? "Partner" : "Plus"), _obj);
        if (isBatch) {
            var isModuleFeatureAvailable = (0,_cont_Batch_utils__WEBPACK_IMPORTED_MODULE_6__/* .getIsStoreModule */ .bL)({
                additionalFeatures: additionalFeatures
            });
            var isSyllabusFeatureAvailable = (0,_cont_Batch_utils__WEBPACK_IMPORTED_MODULE_6__/* .getIsStoreSyllabus */ .Sf)({
                additionalFeatures: additionalFeatures
            });
            var batchFeature = "";
            if (isModuleFeatureAvailable) {
                batchFeature = "Module";
            }
            if (isSyllabusFeatureAvailable) {
                batchFeature = "Syllabus";
            }
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .BATCH_UID */ .yg] = courseUID;
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .BATCH_TITLE */ .Oc] = courseTitle;
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .BATCH_TYPE */ .om] = (0,_cont_Batch_utils__WEBPACK_IMPORTED_MODULE_6__/* .getBatchType */ .Eg)(contentType);
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .CURRENT_PAGE_URL */ .y0] = asPath;
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .ADDITIONAL_FEATURES */ .u0] = batchFeature;
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .IS_SELLABLE */ .i2] = isSellable;
        } else if (courseType === _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES || isTestSeries) {
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .TEST_SERIES_UID */ .mS] = courseUID;
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .TEST_SERIES_TITLE */ .Sz] = courseTitle;
        } else {
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .COURSE_UID */ .Nc] = courseUID;
            segmentData[_events_segmentProps__WEBPACK_IMPORTED_MODULE_9__/* .COURSE_TITLE */ .rU] = courseTitle;
        }
        return segmentData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        course,
        isBatch,
        isTestSeries,
        asPath
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAllTypesOfCourseEventProps);


/***/ }),

/***/ 7418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var detect_it__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43295);
/* eslint-disable react-hooks/exhaustive-deps */ 

var useInfiniteScroll = function(callback, scrollElement) {
    var handleScroll = function handleScroll() {
        var pageHeight = getPageHeight();
        var windowHeight = getWindowHeight();
        var scrollPosition = getScrollPosition();
        if (pageHeight - 350 <= windowHeight + scrollPosition) {
            if (!isFetching) setIsFetching(true);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), fetchedExtra = ref1[0], setFetchedExtra = ref1[1];
    var getPageHeight = function() {
        return (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollHeight) || document.documentElement.offsetHeight;
    };
    var getWindowHeight = function() {
        return (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.offsetHeight) || window.innerHeight;
    };
    var getScrollPosition = function() {
        return (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollTop) || window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var pageHeight = getPageHeight();
        var windowHeight = getWindowHeight();
        var scrollPosition = getScrollPosition();
        // Check if the height of the window or scrollElement is not scrollable due to the pageHeight being less than or equal to the window height.
        if (scrollPosition === 0 && windowHeight >= pageHeight && !fetchedExtra) {
            // Load some data to fill some extra info to populate till scroll.
            setFetchedExtra(true); // To ensure that in case there is no data due to which the screen is blank, there isn't an infinite API call sequence.
            setTimeout(function() {
                setIsFetching(true);
            }, 1000);
        }
        if (scrollElement) {
            scrollElement.addEventListener("scroll", handleScroll, detect_it__WEBPACK_IMPORTED_MODULE_1__/* ["default"].passiveEvents */ .Z.passiveEvents === true ? {
                capture: false,
                passive: true
            } : false);
            return function() {
                return scrollElement.removeEventListener("scroll", handleScroll);
            };
        }
        window.addEventListener("scroll", handleScroll, detect_it__WEBPACK_IMPORTED_MODULE_1__/* ["default"].passiveEvents */ .Z.passiveEvents === true ? {
            capture: false,
            passive: true
        } : false);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isFetching) return;
        var timeout = setTimeout(callback, 100);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isFetching
    ]);
    return [
        isFetching,
        setIsFetching
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useInfiniteScroll);


/***/ }),

/***/ 60722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31309);
/* harmony import */ var _models_Me__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92942);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97428);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43135);
/* harmony import */ var _hooks_usePlatformInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79592);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73060);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58063);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44545);













var getBatchState = function(startDate, completedDate) {
    if (!startDate || !completedDate) return "NA";
    var currentDate = new Date();
    var d1 = new Date(startDate);
    var d2 = new Date(completedDate);
    if (currentDate < d1) return "Upcoming";
    if (currentDate > d2) return "Finished";
    return "Ongoing";
};
var usePlatformEventProps = function(param) {
    var _batch = param.batch, batch = _batch === void 0 ? {} : _batch, _isBatch = param.isBatch, isBatch = _isBatch === void 0 ? false : _isBatch, _entityContentType = param.entityContentType, entityContentType = _entityContentType === void 0 ? false : _entityContentType, _lastPrimarySourceSection = param.lastPrimarySourceSection, lastPrimarySourceSection = _lastPrimarySourceSection === void 0 ? "NA" : _lastPrimarySourceSection, _lastPrimarySource = param.lastPrimarySource, lastPrimarySource = _lastPrimarySource === void 0 ? null : _lastPrimarySource, _extraProps = param.extraProps, extraProps = _extraProps === void 0 ? {} : _extraProps, _isPurchaseType = param.isPurchaseType, isPurchaseType = _isPurchaseType === void 0 ? false : _isPurchaseType, _isSlashedPriceType = param.isSlashedPriceType, isSlashedPriceType = _isSlashedPriceType === void 0 ? false : _isSlashedPriceType;
    var me = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_10__/* .getMe */ .jo);
    var isRegistered = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_11__/* .getIsRegistered */ .eG);
    var batchGroupSubscriptions = (0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__/* .getBatchGroupSubscriptions */ .rN)(me.purchasedItems);
    var activeBatchSubscriptions = (0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__/* .getTotalActiveBatches */ .b8)(me.purchasedItems);
    var batchSubscriptionActive = (0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_8__/* .hasActiveBatch */ .k)(me.purchasedItems);
    var info = (0,_hooks_usePlatformInfo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(batch);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref = batch || {}, startsAt = ref.startsAt, authors = ref.authors, completedAt = ref.completedAt, isEnrolled = ref.isEnrolled, languages = ref.languages, goal = ref.goal, sessions = ref.lessonsCount, enrollmentEndDate = ref.enrollmentEndDate, batchExpiryDate = ref.batchExpiryDate, trialClasses = ref.trialClasses, discountEndDate = ref.discountEndDate;
        var ref1 = goal || {}, goalUID = ref1.uid, goalName = ref1.name;
        var ref2;
        var subscription = (ref2 = (0,_models_Me__WEBPACK_IMPORTED_MODULE_2__/* .getBatchSubscriptionByBatchUID */ .z0)(batchGroupSubscriptions, batch === null || batch === void 0 ? void 0 : batch.uid)) !== null && ref2 !== void 0 ? ref2 : {};
        var _user_subscription_timeline = subscription.user_subscription_timeline, user_subscription_timeline = _user_subscription_timeline === void 0 ? [
            {}
        ] : _user_subscription_timeline;
        var ref3 = user_subscription_timeline[0] || {}, _time_remaining = ref3.time_remaining, time_remaining = _time_remaining === void 0 ? 0 : _time_remaining, _expired_at = ref3.expired_at, expired_at = _expired_at === void 0 ? 0 : _expired_at, _duration = ref3.duration, duration = _duration === void 0 ? 0 : _duration, subscription_type = ref3.subscription_type, tmp = ref3.started_at, purchasedDate = tmp === void 0 ? 0 : tmp;
        var getSubscriptionType = function(type) {
            var entries = Object.entries(_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .subscriptionTypes */ .Lw);
            var subscribedType = entries.find(function(entry) {
                return entry[1] === type;
            });
            return subscribedType ? subscribedType[0] : "NA";
        };
        var is_subscription_active = time_remaining > 0;
        var hasBatchSubscription = !!subscription.user_subscription_timeline;
        // eslint-disable-next-line no-nested-ternary
        var purchaseType = hasBatchSubscription ? hasBatchSubscription.time_remaining ? "extension" : "renewal" : "new";
        var segmentData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
            entity_uid: batch === null || batch === void 0 ? void 0 : batch.uid,
            entity_title: batch === null || batch === void 0 ? void 0 : batch.name,
            start_date: startsAt,
            end_date: completedAt,
            batch_expiry_date: batchExpiryDate || "NA",
            educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors) || "NA",
            educator_uid_list: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors) || "NA",
            educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "name") || "NA",
            educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "username") || "NA",
            educator_username_list: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "username") || "NA",
            educator_name_list: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(authors, "name") || "NA",
            number_of_sessions: sessions || "NA",
            days_till_batch_end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(true, completedAt),
            days_till_enrollment_end: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(true, enrollmentEndDate),
            number_of_active_batch_subscription: activeBatchSubscriptions,
            is_enrolled: isEnrolled || false,
            purchase_enrollment_end_datediff: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(false, enrollmentEndDate, purchasedDate),
            language: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_1__/* .getCommaSeparatedUIDs */ .$V)(languages, "label") || "NA",
            goal_name: goalName,
            goal_uid: goalUID,
            is_subscription_active: is_subscription_active,
            is_batch_subscription_active: batchSubscriptionActive,
            last_primary_source_section: lastPrimarySourceSection,
            subscription_duration: duration || "NA",
            subscription_end_date: expired_at || "NA",
            user_subscription_type: getSubscriptionType(subscription_type),
            has_trial_classes: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(trialClasses),
            is_new_user: !isRegistered,
            is_upgrade: "NA"
        }, extraProps);
        if (isBatch) {
            segmentData.subscription_price = (batch === null || batch === void 0 ? void 0 : batch.price) || "NA";
            segmentData.batch_title = batch === null || batch === void 0 ? void 0 : batch.name;
            segmentData.batch_state = getBatchState(startsAt, completedAt);
            segmentData.batch_uid = batch === null || batch === void 0 ? void 0 : batch.batchUID;
        }
        if (entityContentType) {
            segmentData.entity_content_type = info === null || info === void 0 ? void 0 : info.entityContentType;
        }
        if (isPurchaseType) {
            segmentData.purchase_type = purchaseType;
        }
        if (lastPrimarySource) {
            segmentData.last_primary_source = lastPrimarySource;
        }
        if (isSlashedPriceType) {
            var ref4;
            segmentData.is_price_slashed = (ref4 = batch === null || batch === void 0 ? void 0 : batch.isDiscountAvailable) !== null && ref4 !== void 0 ? ref4 : false;
            segmentData.num_days_to_price_increase = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDays */ .MK)(true, discountEndDate);
            segmentData.listing_price = (batch === null || batch === void 0 ? void 0 : batch.listPrice) || "NA";
        }
        return segmentData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        batch,
        batchSubscriptionActive
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePlatformEventProps);


/***/ }),

/***/ 22609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ fetchQuizLeaderBoard; },
/* harmony export */   "Eg": function() { return /* binding */ rejectSubjectiveAnswerUpload; },
/* harmony export */   "FG": function() { return /* binding */ submitBulkAnswers; },
/* harmony export */   "Fu": function() { return /* binding */ fetchQuizFeedbackOptions; },
/* harmony export */   "Ne": function() { return /* binding */ fetchSolutionFilters; },
/* harmony export */   "QW": function() { return /* binding */ fetchQuizData; },
/* harmony export */   "SP": function() { return /* binding */ fetchActiveSessionData; },
/* harmony export */   "ZB": function() { return /* binding */ sendViewedQuestion; },
/* harmony export */   "Zc": function() { return /* binding */ setQuizLoadingState; },
/* harmony export */   "al": function() { return /* binding */ fetchStaticQuestions; },
/* harmony export */   "bH": function() { return /* binding */ submitAnswerResponse; },
/* harmony export */   "eA": function() { return /* binding */ fetchQuizAnalytics; },
/* harmony export */   "fk": function() { return /* binding */ finishSection; },
/* harmony export */   "fq": function() { return /* binding */ fetchDSTQuizCommonReport; },
/* harmony export */   "g0": function() { return /* binding */ enrollInQuiz; },
/* harmony export */   "hr": function() { return /* binding */ setModalState; },
/* harmony export */   "hy": function() { return /* binding */ fetchQuizRank; },
/* harmony export */   "iG": function() { return /* binding */ fetchVideoSolutionFeedbackOptions; },
/* harmony export */   "jA": function() { return /* binding */ fetchSessionDetails; },
/* harmony export */   "kE": function() { return /* binding */ finishQuiz; },
/* harmony export */   "kM": function() { return /* binding */ setCurrentSelectedAnswer; },
/* harmony export */   "kX": function() { return /* binding */ toggleMarkQuestion; },
/* harmony export */   "l2": function() { return /* binding */ cleanUpAfterQuizEnds; },
/* harmony export */   "m0": function() { return /* binding */ setLanguage; },
/* harmony export */   "mi": function() { return /* binding */ uploadSubjectiveAnswer; },
/* harmony export */   "oQ": function() { return /* binding */ fetchQuestionReportOptions; },
/* harmony export */   "qT": function() { return /* binding */ setCurrentQuestionInfo; },
/* harmony export */   "qY": function() { return /* binding */ fetchQuizMinimalData; },
/* harmony export */   "qn": function() { return /* binding */ fetchSolutions; },
/* harmony export */   "tP": function() { return /* binding */ submitVideoSolutionFeedback; },
/* harmony export */   "tt": function() { return /* binding */ fetchEvaluatedSheet; },
/* harmony export */   "uv": function() { return /* binding */ fetchSolutionFeedbackOptions; }
/* harmony export */ });
/* unused harmony exports getQuizEndpointByType, fetchQuizAttempts, fetchQuestionsWithAttempts, fetchQuizCommonReport */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16483);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54051);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72894);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38037);
/* harmony import */ var _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46514);


/* eslint-disable max-lines */ 




var getQuizEndpointByType = function(endpoint) {
    var quizType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var isSubjective = quizType.isSubjective;
    if (isSubjective) {
        return endpoint.replace(/\/quiz\//, "/sts-quiz/").replace(/\/session\//, "/sts-session/");
    }
    return endpoint;
};
var getHostByType = function(quizType) {
    var isSubjective = quizType.isSubjective;
    if (isSubjective) {
        return _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_2__/* .HOST_TYPE.DEFAULT */ .Bk.DEFAULT;
    }
    return _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_2__/* .HOST_TYPE.TEST_SERIES */ .Bk.TEST_SERIES;
};
var fetchQuizData = function(quizUID) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_DETAILS */ .Z.QUIZ_FETCH_DETAILS,
        endpoint: "v3/quizzes/quiz/".concat(quizUID, "/details/"),
        method: "get",
        quizUID: quizUID,
        useSearchToken: true,
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_2__/* .HOST_TYPE.TEST_SERIES */ .Bk.TEST_SERIES
    };
};
var fetchQuizAttempts = function(quizUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/quiz/".concat(quizUID, "/my_attempts/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_ATTEMPTS */ .Z.QUIZ_FETCH_ATTEMPTS,
            endpoint: endpoint,
            method: "get",
            quizUID: quizUID,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var fetchQuizMinimalData = function(quizUID) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var is_whitelisted;
            return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(fetchQuizData(quizUID));
                    case 2:
                        is_whitelisted = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getQuizDetails */ .cU)(quizUID)(getState()).is_whitelisted;
                        if (!is_whitelisted) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return dispatch(fetchQuizAttempts(quizUID));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchStaticQuestions = function(quizUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/quiz/".concat(quizUID, "/questions/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_STATIC_QUESTIONS */ .Z.QUIZ_FETCH_STATIC_QUESTIONS,
            endpoint: endpoint,
            method: "get",
            quizUID: quizUID,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var enrollInQuiz = function(quizUID, selectedLanguageCode, isRevampedTestVersion2) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var isSubjective = quizType.isSubjective;
        var version = isSubjective ? "v2" : "v3";
        var endpoint = getQuizEndpointByType("".concat(version, "/quizzes/quiz/").concat(quizUID, "/enroll/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_ENROLL */ .Z.QUIZ_ENROLL,
            endpoint: endpoint,
            method: "post",
            data: {
                language: selectedLanguageCode
            },
            quizUID: quizUID,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType,
            isRevampedTestVersion2: isRevampedTestVersion2
        }).then(function(resp) {
            // For objective fetch the questions
            if (!resp.error && !isSubjective) {
                return dispatch(fetchStaticQuestions(quizUID));
            }
            return resp;
        });
    };
};
var fetchSubmittedQuestions = function(quizUID, sessionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/submissions/"), quizType);
        var isSubjective = quizType.isSubjective;
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_SUBMITTED_QUESTIONS */ .Z.QUIZ_FETCH_SUBMITTED_QUESTIONS,
            endpoint: endpoint,
            method: "get",
            quizUID: quizUID,
            sessionUID: sessionUID,
            isSubjective: isSubjective,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var fetchQuestionsWithAttempts = function(quizUID, sessionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_QUESTIONS_WITH_ATTEMPTS */ .Z.QUIZ_FETCH_QUESTIONS_WITH_ATTEMPTS,
            endpoint: "v2/quizzes/sts-session/".concat(sessionUID, "/get_questions/"),
            method: "get",
            quizUID: quizUID,
            sessionUID: sessionUID,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var fetchActiveSessionData = function(quizUID, sessionUID, isRevampedTestVersion2) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var quizType, isSubjective;
            return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
                        isSubjective = quizType.isSubjective;
                        if (!(isSubjective && !isRevampedTestVersion2)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 5;
                        return dispatch(fetchQuestionsWithAttempts(quizUID, sessionUID));
                    case 5:
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return dispatch(fetchStaticQuestions(quizUID));
                    case 8:
                        _ctx.next = 10;
                        return dispatch(fetchSubmittedQuestions(quizUID, sessionUID));
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var toggleMarkQuestion = function(quizUID, sessionUID, sectionUID, questionUID, isMarked) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/mark_unmark_question/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_MARK_QUESTION */ .Z.QUIZ_MARK_QUESTION,
            endpoint: endpoint,
            method: "post",
            sectionUID: sectionUID,
            questionUID: questionUID,
            isMarked: isMarked,
            data: {
                q_uid: questionUID,
                is_marked: isMarked ? 1 : 0
            },
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var submitAnswerResponse = function(quizUID, sectionUID, sessionUID, data) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v2/quizzes/session/".concat(sessionUID, "/question_response/"), quizType);
        var isSubjective = quizType.isSubjective;
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SUBMIT_QUESTION_RESPONSE */ .Z.QUIZ_SUBMIT_QUESTION_RESPONSE,
            endpoint: endpoint,
            method: "post",
            data: data,
            sectionUID: sectionUID,
            questionUID: data.question_uid,
            attemptList: data.attempt_list,
            isSubjective: isSubjective,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var sendViewedQuestion = function(param) {
    var sessionUID = param.sessionUID, questionUID = param.questionUID, sectionUID = param.sectionUID, isRevampedTestVersion2 = param.isRevampedTestVersion2;
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v2/quizzes/session/".concat(sessionUID, "/viewed_question/"), quizType);
        var questionData = {
            questionUID: questionUID,
            sectionUID: sectionUID,
            isRevampedTestVersion2: isRevampedTestVersion2
        };
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SEND_VIEWED_QUESTION */ .Z.QUIZ_SEND_VIEWED_QUESTION,
            endpoint: endpoint,
            method: "post",
            data: {
                question_uid: questionUID
            },
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType,
            questionData: questionData
        });
    };
};
var finishSection = function(quizUID, sessionUID, sectionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/finish_section/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FINISH_SECTION */ .Z.QUIZ_FINISH_SECTION,
            endpoint: endpoint,
            method: "post",
            data: {
                section_uid: sectionUID
            },
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var finishQuiz = function(quizUID, sessionUID, isDSTFlow) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = isDSTFlow ? "scholarship/v1/".concat(sessionUID, "/finish_test") : getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/finish_quiz/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FINISH_QUIZ */ .Z.QUIZ_FINISH_QUIZ,
            endpoint: endpoint,
            method: "post",
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var submitBulkAnswers = function(quizUID, sessionUID, data) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/bulk_submit_question_response/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SUBMIT_BULK_ANSWERS */ .Z.QUIZ_SUBMIT_BULK_ANSWERS,
            endpoint: endpoint,
            method: "post",
            data: {
                question_response: data
            },
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var fetchQuestionReportOptions = function() {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_QUESTION_REPORT_OPTIONS */ .Z.QUIZ_FETCH_QUESTION_REPORT_OPTIONS,
        endpoint: "v1/feedback/question/",
        method: "get"
    };
};
var fetchSolutionFeedbackOptions = function() {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_SOLUTION_FEEDBACK_OPTIONS */ .Z.QUIZ_FETCH_SOLUTION_FEEDBACK_OPTIONS,
        endpoint: "v1/feedback/question_solution/",
        method: "get"
    };
};
var fetchVideoSolutionFeedbackOptions = function() {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_VIDEO_SOLUTION_FEEDBACK_OPTIONS */ .Z.QUIZ_FETCH_VIDEO_SOLUTION_FEEDBACK_OPTIONS,
        endpoint: "v1/feedback/contest_question_solution/",
        method: "get"
    };
};
var submitVideoSolutionFeedback = function(UID, data) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SUBMIT_VIDEO_SOLUTION_FEEDBACK */ .Z.QUIZ_SUBMIT_VIDEO_SOLUTION_FEEDBACK,
        endpoint: "v1/feedback/".concat(UID, "/response/"),
        method: "post",
        data: data
    };
};
var fetchSessionDetails = function(quizUID, sessionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/details/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_SESSION_DETAILS */ .Z.QUIZ_FETCH_SESSION_DETAILS,
            endpoint: endpoint,
            method: "get",
            sessionUID: sessionUID,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var fetchSolutionFilters = function(quizUID, sessionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/get_filter/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_SOLUTION_FILTER */ .Z.QUIZ_FETCH_SOLUTION_FILTER,
            endpoint: endpoint,
            method: "get",
            sessionUID: sessionUID,
            useSearchToken: true,
            hostType: hostType
        });
    };
};
var getQuizSolutions = function(sessionUID, resetWithoutEmpty, hostType) {
    return function(next) {
        return {
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_PAGINATED_SOLUTIONS */ .Z.QUIZ_FETCH_PAGINATED_SOLUTIONS,
            endpoint: next,
            method: "get",
            key: sessionUID,
            resetWithoutEmpty: resetWithoutEmpty,
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        };
    };
};
var fetchSolutions = function(quizUID, sessionUID) {
    var quizType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, key = arguments.length > 3 ? arguments[3] : void 0, data = arguments.length > 4 ? arguments[4] : void 0, nextPage = arguments.length > 5 ? arguments[5] : void 0, resetWithoutEmpty = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    var hostType = getHostByType(quizType);
    var endpoint = getQuizEndpointByType("v2/quizzes/session/".concat(sessionUID, "/get_questions_paginated_with_attempts/?attempt_type=").concat(data.solutionType, "&").concat(data.hasDefaultSection ? "topic_group" : "section_uid", "=").concat(data.sectionUID, "&topic_uid=").concat(data.topicUID, "&limit=15"), quizType);
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(endpoint, getQuizSolutions(key, resetWithoutEmpty, hostType), "quizSolutions", key, resetWithoutEmpty)(nextPage);
};
var fetchQuizCommonReport = function(quizUID, sessionUID) {
    return function(dispatch) {
        var endpoint = "v1/quizzes/quiz/".concat(quizUID, "/common_report/");
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_COMMON_REPORT */ .Z.QUIZ_FETCH_COMMON_REPORT,
            endpoint: endpoint,
            method: "get",
            sessionUID: sessionUID,
            useSearchToken: true,
            hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_2__/* .HOST_TYPE.TEST_SERIES */ .Bk.TEST_SERIES
        });
    };
};
var fetchDSTQuizCommonReport = function(quizUID, sessionUID) {
    return function(dispatch) {
        var endpoint = "scholarship/v1/".concat(sessionUID, "/result");
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_COMMON_REPORT */ .Z.QUIZ_FETCH_COMMON_REPORT,
            endpoint: endpoint,
            method: "get",
            sessionUID: sessionUID,
            useSearchToken: true,
            hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_2__/* .HOST_TYPE.TEST_SERIES */ .Bk.TEST_SERIES
        });
    };
};
var fetchQuizAnalytics = function(quizUID, sessionUID, isDST) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
            var quizType, hostType, is_whitelisted, endpoint;
            return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
                        hostType = getHostByType(quizType);
                        is_whitelisted = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getQuizDetails */ .cU)(quizUID)(getState()).is_whitelisted;
                        endpoint = getQuizEndpointByType("".concat(is_whitelisted ? "v2" : "v1", "/quizzes/session/").concat(sessionUID, "/get_elastic_analytics_report/"), quizType);
                        if (!isDST) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return dispatch(fetchDSTQuizCommonReport(quizUID, sessionUID));
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        if (!is_whitelisted) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 12;
                        return dispatch(fetchQuizCommonReport(quizUID, sessionUID));
                    case 12:
                        return _ctx.abrupt("return", dispatch({
                            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_ANALYTICS_REPORT */ .Z.QUIZ_FETCH_ANALYTICS_REPORT,
                            endpoint: endpoint,
                            method: "get",
                            sessionUID: sessionUID,
                            useSearchToken: hostType !== "DEFAULT",
                            hostType: hostType
                        }));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchQuizRank = function(quizUID, sessionUID, isLive) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var is_whitelisted = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getQuizDetails */ .cU)(quizUID)(getState()).is_whitelisted;
        var endpoint = getQuizEndpointByType("".concat(is_whitelisted ? "v2" : "v1", "/quizzes/quiz/").concat(quizUID, "/get_user_rank/?is_live=").concat(isLive ? 1 : 0), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_USER_RANK */ .Z.QUIZ_FETCH_USER_RANK,
            isWhitelisted: is_whitelisted,
            endpoint: endpoint,
            method: "get",
            quizUID: quizUID,
            sessionUID: sessionUID,
            useSearchToken: true,
            hostType: hostType
        });
    };
};
var setQuizLoadingState = function(value) {
    return function(dispatch) {
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_LOADING */ .Z.QUIZ_LOADING,
            value: value
        });
    };
};
var fetchEvaluatedSheet = function(quizUID, sessionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/get_evaluated_sheet/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_EVALUATED_SHEET */ .Z.QUIZ_FETCH_EVALUATED_SHEET,
            endpoint: endpoint,
            method: "get",
            sessionUID: sessionUID,
            useSearchToken: true,
            hostType: hostType
        });
    };
};
var fetchQuizFeedbackOptions = function(quizUID) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_FEEDBACK_OPTIONS */ .Z.QUIZ_FETCH_FEEDBACK_OPTIONS,
        endpoint: "v1/feedback/test/?object_uid=".concat(quizUID),
        method: "get",
        quizUID: quizUID
    };
};
var rejectSubjectiveAnswerUpload = function(quizUID, sessionUID) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/reject_upload/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_REJECT_SUBJECTIVE_ANSWER_UPLOAD */ .Z.QUIZ_REJECT_SUBJECTIVE_ANSWER_UPLOAD,
            endpoint: endpoint,
            method: "post",
            useSearchToken: true,
            hostType: hostType
        });
    };
};
var uploadSubjectiveAnswer = function(quizUID, sessionUID, urls) {
    return function(dispatch, getState) {
        var quizType = (0,_selectors_quizTaking__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentQuizType */ .dc)(getState());
        var hostType = getHostByType(quizType);
        var endpoint = getQuizEndpointByType("v1/quizzes/session/".concat(sessionUID, "/upload_answers/"), quizType);
        return dispatch({
            type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_UPLOAD_SUBJECTIVE_ANSWER */ .Z.QUIZ_UPLOAD_SUBJECTIVE_ANSWER,
            endpoint: endpoint,
            method: "post",
            data: {
                s3url_list: urls
            },
            useSearchToken: hostType !== "DEFAULT",
            hostType: hostType
        });
    };
};
var getQuizLeaderboard = function(key, isLive, resetWithoutEmpty, hostType) {
    return function(next) {
        return {
            type: isLive ? _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_LEADERBOARD_LIVE */ .Z.QUIZ_FETCH_LEADERBOARD_LIVE : _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_FETCH_LEADERBOARD_ALL */ .Z.QUIZ_FETCH_LEADERBOARD_ALL,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_3__/* .paginatorListSchema */ .EH,
            useSearchToken: true,
            hostType: hostType
        };
    };
};
var fetchQuizLeaderBoard = function(param) {
    var quizUID = param.quizUID, isLive = param.isLive, nextPage = param.nextPage, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty, _quizType = param.quizType, quizType = _quizType === void 0 ? {} : _quizType;
    var key = isLive ? "quizLeaderboardLive" : "quizLeaderboardAll";
    var hostType = getHostByType(quizType);
    var endpoint = getQuizEndpointByType("v2/quizzes/quiz/".concat(quizUID, "/get_quiz_leaderboard/?is_live=").concat(isLive ? 1 : 0, "&limit=15&offset=0"), quizType);
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(endpoint, getQuizLeaderboard(quizUID, isLive, resetWithoutEmpty, hostType), key, quizUID, resetWithoutEmpty)(nextPage);
};
var cleanUpAfterQuizEnds = function() {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_CLEAN_UP_AFTER_QUIZ_END */ .Z.QUIZ_CLEAN_UP_AFTER_QUIZ_END
    };
};
var setCurrentQuestionInfo = function(data) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SET_CURRENT_QUESTION_TYPE */ .Z.QUIZ_SET_CURRENT_QUESTION_TYPE,
        data: data
    };
};
var setCurrentSelectedAnswer = function(data) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SET_CURRENT_SELECTED_ANSWER */ .Z.QUIZ_SET_CURRENT_SELECTED_ANSWER,
        data: data
    };
};
var setModalState = function(data) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_MODAL_TYPE */ .Z.QUIZ_MODAL_TYPE,
        data: data
    };
};
var setLanguage = function(data) {
    return {
        type: _constants_quizTaking__WEBPACK_IMPORTED_MODULE_4__/* ["default"].QUIZ_SET_SELECTED_LANGUAGE */ .Z.QUIZ_SET_SELECTED_LANGUAGE,
        data: data
    };
};


/***/ }),

/***/ 50985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ createTest; },
/* harmony export */   "Bv": function() { return /* binding */ editQuizInTemplate; },
/* harmony export */   "Dv": function() { return /* binding */ fetchTemplate; },
/* harmony export */   "E$": function() { return /* binding */ clearTemplateField; },
/* harmony export */   "HC": function() { return /* binding */ updateTemplateEvaluationCriteria; },
/* harmony export */   "Ou": function() { return /* binding */ searchTemplate; },
/* harmony export */   "Vf": function() { return /* binding */ updateTemplateDetails; },
/* harmony export */   "WQ": function() { return /* binding */ createQuizInTemplate; },
/* harmony export */   "Xc": function() { return /* binding */ deleteTemplate; },
/* harmony export */   "e9": function() { return /* binding */ updateTemplateInstructions; },
/* harmony export */   "f7": function() { return /* binding */ resetEditForm; },
/* harmony export */   "fF": function() { return /* binding */ updateEducatorSlides; },
/* harmony export */   "ge": function() { return /* binding */ defaultTemplateDetails; },
/* harmony export */   "gg": function() { return /* binding */ updateOrCreateTemplate; },
/* harmony export */   "m1": function() { return /* binding */ setTemplateErrors; },
/* harmony export */   "mU": function() { return /* binding */ updateTemplateSettings; },
/* harmony export */   "op": function() { return /* binding */ fetchTemplateDetails; },
/* harmony export */   "pK": function() { return /* binding */ fetchTemplates; },
/* harmony export */   "vy": function() { return /* binding */ addOrUpdateTemplateSection; },
/* harmony export */   "we": function() { return /* binding */ fetchTestState; }
/* harmony export */ });
/* unused harmony export getTemplates */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72894);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94336);




var defaultTemplateDetails = {
    count: 0,
    languages: [],
    "max-answered": "",
    "calculator-type": -1,
    subject: []
};
var defaultTemplateForm = {
    description: "",
    title: "",
    "test-type": 1,
    "cuttoff-marks": 0,
    details: defaultTemplateDetails,
    duration: 0,
    instructions: "",
    goal: {}
};
var getTemplates = function(param) {
    var key = param.key, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty;
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.FETCH_TEMPLATES */ .z1.FETCH_TEMPLATES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty
        };
    };
};
var fetchTemplates = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, goalUID = ref.goalUID, duration = ref.duration, nextPage = ref.nextPage, _forceReset = ref.forceReset, forceReset = _forceReset === void 0 ? false : _forceReset;
    var key = goalUID || "allTemplates";
    var endpoint = "v1/quizzes/templates/list_templates/?limit=6&offset=0";
    if (goalUID) {
        endpoint += "&goal_uid=".concat(goalUID);
    }
    if (duration) {
        endpoint += "&duration=".concat(duration);
    }
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(endpoint, getTemplates({
        key: key,
        resetWithoutEmpty: forceReset
    }), "testSeriesTemplates", key, false, forceReset)(nextPage);
};
var searchTemplate = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, goalUID = ref.goalUID, duration = ref.duration, query = ref.query, nextPage = ref.nextPage, _forceReset = ref.forceReset, forceReset = _forceReset === void 0 ? false : _forceReset;
    var key = "".concat(query).concat(goalUID || "");
    var endpoint = "v1/quizzes/templates/search_template/?title=".concat(query);
    if (goalUID) {
        endpoint += "&goal_uid=".concat(goalUID);
    }
    if (duration) {
        endpoint += "&duration=".concat(duration);
    }
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(endpoint, getTemplates({
        key: key,
        resetWithoutEmpty: forceReset
    }), "testSeriesTemplates", key, false, forceReset)(nextPage);
};
var fetchTemplate = function(id) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.FETCH_TEMPLATE */ .z1.FETCH_TEMPLATE,
        endpoint: "v1/quizzes/templates/search_template/?_id=".concat(id),
        method: "get"
    };
};
var deleteTemplate = function(templateID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.DELETE_TEMPLATE */ .z1.DELETE_TEMPLATE,
        endpoint: "v1/quizzes/templates/delete_test_template/",
        method: "post",
        data: {
            template_id: templateID
        }
    };
};
var updateOrCreateTemplate = function(data, templateID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.UPDATE_OR_CREATE_TEMPLATE */ .z1.UPDATE_OR_CREATE_TEMPLATE,
        endpoint: "v1/quizzes/templates/create_update_test_template/",
        method: "post",
        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, templateID && {
            id: templateID
        }), {
            template: data
        })
    };
};
var createTest = function(data, uid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.CREATE_TEST_FOR_TEMPLATE */ .z1.CREATE_TEST_FOR_TEMPLATE,
        endpoint: "v2/quizzes/me/edit/".concat(uid, "/"),
        method: "post",
        data: data
    };
};
var resetEditForm = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.RESET_TEMPLATE_FORM */ .z1.RESET_TEMPLATE_FORM,
        data: defaultTemplateForm
    };
};
var updateTemplateSettings = function(name, value) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.UPDATE_TEMPLATE_SETTINGS */ .z1.UPDATE_TEMPLATE_SETTINGS,
        name: name,
        value: value
    };
};
var updateTemplateDetails = function(name, value, isAddType) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.UPDATE_TEMPLATE_DETAILS */ .z1.UPDATE_TEMPLATE_DETAILS,
        name: name,
        value: value,
        isAddType: isAddType
    };
};
var addOrUpdateTemplateSection = function(value, position) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.ADD_OR_UPDATE_TEMPLATE_SECTION */ .z1.ADD_OR_UPDATE_TEMPLATE_SECTION,
        value: value,
        isAddType: position === null,
        position: position
    };
};
var updateTemplateEvaluationCriteria = function(position, value) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.UPDATE_TEMPLATE_EVALUATION_CRITERIA */ .z1.UPDATE_TEMPLATE_EVALUATION_CRITERIA,
        position: position,
        value: value
    };
};
var updateTemplateInstructions = function(value) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.UPDATE_TEMPLATE_INSTRUCTIONS */ .z1.UPDATE_TEMPLATE_INSTRUCTIONS,
        value: value
    };
};
var setTemplateErrors = function(errors) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.SET_TEMPLATE_ERRORS */ .z1.SET_TEMPLATE_ERRORS,
        errors: errors
    };
};
var fetchTemplateDetails = function(templateUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.FETCH_TEST_TEMPLATE_DETAILS */ .z1.FETCH_TEST_TEMPLATE_DETAILS,
        endpoint: "v1/quizzes/templates/get_template_detail/?id=".concat(templateUID),
        method: "get",
        templateUID: templateUID
    };
};
var createQuizInTemplate = function(data) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.CREATE_QUIZ_IN_TEMPLATE */ .z1.CREATE_QUIZ_IN_TEMPLATE,
        endpoint: "v2/quizzes/me/create/",
        method: "post",
        data: data
    };
};
var editQuizInTemplate = function(data, uid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.EDIT_QUIZ_IN_TEMPLATE */ .z1.EDIT_QUIZ_IN_TEMPLATE,
        endpoint: "v2/quizzes/me/edit_template/".concat(uid, "/"),
        method: "post",
        data: data
    };
};
var fetchTestState = function(templateUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.FETCH_TEST_STATE */ .z1.FETCH_TEST_STATE,
        endpoint: "v1/uplus/course_template/quiz_info/?id=".concat(templateUID),
        method: "get"
    };
};
var clearTemplateField = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], isContentOp = arguments.length > 1 ? arguments[1] : void 0;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.CLEAR_TEMPLATE_FIELDS */ .z1.CLEAR_TEMPLATE_FIELDS,
        ids: ids,
        isContentOp: isContentOp
    };
};
var updateEducatorSlides = function(data, uid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .templatesTypes.UPDATE_EDUCATOR_SLIDES */ .z1.UPDATE_EDUCATOR_SLIDES,
        data: data,
        uid: uid
    };
};


/***/ }),

/***/ 16483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ getAllSectionalAnswers; },
/* harmony export */   "BZ": function() { return /* binding */ getQuestionReportOptions; },
/* harmony export */   "Bm": function() { return /* binding */ getIsPendingAction; },
/* harmony export */   "Bz": function() { return /* binding */ getAvailableLanguages; },
/* harmony export */   "Df": function() { return /* binding */ getGoalUId; },
/* harmony export */   "G7": function() { return /* binding */ getFeedbackOptions; },
/* harmony export */   "Hr": function() { return /* binding */ getIsUserEnrolledInQuiz; },
/* harmony export */   "Nd": function() { return /* binding */ getCurrentSessionUID; },
/* harmony export */   "O$": function() { return /* binding */ getIsSolutionQuestionsaved; },
/* harmony export */   "O1": function() { return /* binding */ getUnansweredQuestions; },
/* harmony export */   "OQ": function() { return /* binding */ getQuizSessionDetails; },
/* harmony export */   "RO": function() { return /* binding */ getHasDefaultSection; },
/* harmony export */   "SG": function() { return /* binding */ getModalState; },
/* harmony export */   "Sq": function() { return /* binding */ getOngoingSectionDetails; },
/* harmony export */   "St": function() { return /* binding */ getTotalSessionCount; },
/* harmony export */   "UM": function() { return /* binding */ getUserRank; },
/* harmony export */   "VA": function() { return /* binding */ getQuizSection; },
/* harmony export */   "Vc": function() { return /* binding */ getAllQuestionsBySection; },
/* harmony export */   "Vg": function() { return /* binding */ getAllMarkedQuestions; },
/* harmony export */   "YI": function() { return /* binding */ getSelectedLanguage; },
/* harmony export */   "ZF": function() { return /* binding */ getIsQuizForPlusUsers; },
/* harmony export */   "Zp": function() { return /* binding */ getLeaderboard; },
/* harmony export */   "_N": function() { return /* binding */ getmaxAnswerableQuestions; },
/* harmony export */   "a5": function() { return /* binding */ getQuestion; },
/* harmony export */   "aQ": function() { return /* binding */ getLatestSessionUID; },
/* harmony export */   "b6": function() { return /* binding */ getCurrentQuestionInfo; },
/* harmony export */   "cU": function() { return /* binding */ getQuizDetails; },
/* harmony export */   "ct": function() { return /* binding */ getCalculatorType; },
/* harmony export */   "dA": function() { return /* binding */ getIsQuestionUnanswered; },
/* harmony export */   "dT": function() { return /* binding */ getQuizSessionAnalytics; },
/* harmony export */   "dW": function() { return /* binding */ getIsQuestionMarked; },
/* harmony export */   "dc": function() { return /* binding */ getCurrentQuizType; },
/* harmony export */   "gN": function() { return /* binding */ getdefaultSectionUID; },
/* harmony export */   "h9": function() { return /* binding */ getPreviousSessions; },
/* harmony export */   "hI": function() { return /* binding */ getQuizSolutionFeedbackOptions; },
/* harmony export */   "kG": function() { return /* binding */ getQuizVideoSolutionFeedbackOptions; },
/* harmony export */   "lX": function() { return /* binding */ getQuizSolutions; },
/* harmony export */   "o": function() { return /* binding */ getAllAnswersBySection; },
/* harmony export */   "oQ": function() { return /* binding */ getQuizQuestionAnswers; },
/* harmony export */   "oR": function() { return /* binding */ getQuizSectionalQuestions; },
/* harmony export */   "rN": function() { return /* binding */ getSolutionSecondLevelFiltersByUID; },
/* harmony export */   "rP": function() { return /* binding */ getEvaluatedSheets; },
/* harmony export */   "sK": function() { return /* binding */ getHasFetchedQuizQuestions; },
/* harmony export */   "sd": function() { return /* binding */ getQuizSyllabus; },
/* harmony export */   "sn": function() { return /* binding */ getIsQuizLoading; },
/* harmony export */   "vD": function() { return /* binding */ getIsQuizFeedbackGiven; },
/* harmony export */   "w4": function() { return /* binding */ getSolutionFirstLevelFilters; },
/* harmony export */   "wG": function() { return /* binding */ getCurrentQuestion; },
/* harmony export */   "xP": function() { return /* binding */ getmaxAnswerableQuestion; },
/* harmony export */   "xc": function() { return /* binding */ getCurrentSelectedAnswer; },
/* harmony export */   "y_": function() { return /* binding */ getCurrentSession; },
/* harmony export */   "zu": function() { return /* binding */ getMinRankAPIDelay; }
/* harmony export */ });
/* unused harmony exports getQuizAuthor, getHasCalculator, getEvaluatedSheet, getLiveLeaderboard, getOverallLeaderboard */
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59375);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43135);



var getIsPendingAction = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.isPendingAction || false;
};
var getIsQuizLoading = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.isQuizLoading;
};
var getQuizDetails = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return (quizTaking === null || quizTaking === void 0 ? void 0 : (ref = quizTaking.data) === null || ref === void 0 ? void 0 : ref[quizUID]) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getCurrentQuizType = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.currentQuizType || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
};
var getQuizAuthor = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return "".concat(quizTaking.data[quizUID].author.first_name, " ").concat(quizTaking.data[quizUID].author.last_name);
    };
};
var getPreviousSessions = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return ((ref = quizTaking.data[quizUID]) === null || ref === void 0 ? void 0 : ref.previous_sessions) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyList */ .n8;
    };
};
var getQuizSyllabus = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return ((ref = quizTaking.data[quizUID]) === null || ref === void 0 ? void 0 : ref.syllabus) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyList */ .n8;
    };
};
var getHasDefaultSection = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.data[quizUID].sections.length === 1 && quizTaking.data[quizUID].sections[0].is_default;
    };
};
var getdefaultSectionUID = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return getHasDefaultSection(quizUID) ? quizTaking.data[quizUID].sections[0].uid : null;
    };
};
var getQuizSessionDetails = function(sessionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.sessionDetailsByUID[sessionUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getMinRankAPIDelay = function() {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.minRankAPIDelay;
    };
};
var getQuizSessionAnalytics = function(sessionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.analyticsReportByUID[sessionUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getCurrentSession = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.currentSession;
};
var getQuizSection = function(quizUID, index) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.data[quizUID].sections[index] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getAllQuestionsBySection = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking === null || quizTaking === void 0 ? void 0 : quizTaking.questionsBySection;
};
var getAllAnswersBySection = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.answersBySection;
};
var getAllMarkedQuestions = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.markedQuestionsBySection;
};
var _unansweredQuestionsBySection;
var getUnansweredQuestions = function(param) {
    var quizTaking = param.quizTaking;
    return (_unansweredQuestionsBySection = quizTaking.unansweredQuestionsBySection) !== null && _unansweredQuestionsBySection !== void 0 ? _unansweredQuestionsBySection : _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
};
var getQuizSectionalQuestions = function(quizUID, sectionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.questionsBySection[sectionUID];
    };
};
var getAllSectionalAnswers = function(sectionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.answersBySection[sectionUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getQuizQuestionAnswers = function(sectionUID, questionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return ((ref = quizTaking.answersBySection[sectionUID]) === null || ref === void 0 ? void 0 : ref[questionUID]) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyList */ .n8;
    };
};
var getIsQuestionMarked = function(sectionUID, quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return ((ref = quizTaking.markedQuestionsBySection[sectionUID]) === null || ref === void 0 ? void 0 : ref[quizUID]) || false;
    };
};
var getIsQuestionUnanswered = function(sectionUID, quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref, ref1;
        return (quizTaking === null || quizTaking === void 0 ? void 0 : (ref = quizTaking.unansweredQuestionsBySection) === null || ref === void 0 ? void 0 : (ref1 = ref[sectionUID]) === null || ref1 === void 0 ? void 0 : ref1[quizUID]) || false;
    };
};
var getCurrentSessionUID = function(param) {
    var quizTaking = param.quizTaking;
    var ref;
    return quizTaking === null || quizTaking === void 0 ? void 0 : (ref = quizTaking.currentSession) === null || ref === void 0 ? void 0 : ref.uid;
};
var getLatestSessionUID = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref, ref1;
        return ((ref = quizTaking.data[quizUID]) === null || ref === void 0 ? void 0 : (ref1 = ref.latest_session) === null || ref1 === void 0 ? void 0 : ref1.uid) || null;
    };
};
var getCurrentQuestionInfo = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.currentQuestionInfo;
};
var getCurrentSelectedAnswer = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.currentSelectedAnswer;
};
var getQuestion = function(sectionUID, questionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref, ref1, ref2;
        return ((ref = quizTaking.questionsBySection) === null || ref === void 0 ? void 0 : (ref1 = ref[sectionUID]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.byId) === null || ref2 === void 0 ? void 0 : ref2[questionUID]) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getCurrentQuestion = function(param) {
    var quizTaking = param.quizTaking;
    var ref, ref1, ref2;
    var ref3 = quizTaking.currentQuestionInfo || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD, sectionUID = ref3.sectionUID, questionUID = ref3.questionUID;
    return ((ref = quizTaking.questionsBySection) === null || ref === void 0 ? void 0 : (ref1 = ref[sectionUID]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.byId) === null || ref2 === void 0 ? void 0 : ref2[questionUID]) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
};
var getSelectedLanguage = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.selectedLanguage;
};
var getAvailableLanguages = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.availableLanguages;
};
var getmaxAnswerableQuestions = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.maxAnswerableQuestionBySection;
};
var getmaxAnswerableQuestion = function(sectionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.maxAnswerableQuestionBySection[sectionUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getHasCalculator = function(param) {
    var quizTaking = param.quizTaking;
    return !isEmpty(quizTaking.calculatorTypesBySection);
};
var getCalculatorType = function(sectionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.calculatorTypesBySection[sectionUID] || _constants_index__WEBPACK_IMPORTED_MODULE_2__/* .calculatorType.CALCULATOR_NOT_SELECTED */ .Ar.CALCULATOR_NOT_SELECTED;
    };
};
var getQuestionReportOptions = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.questionReportOptions;
};
var getOngoingSectionDetails = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.ongoingSectionDetails;
};
var getModalState = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.modal || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
};
var getSolutionFirstLevelFilters = function(sessionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return ((ref = quizTaking.solutionFilterBySession[sessionUID]) === null || ref === void 0 ? void 0 : ref.solutionFirstLevelFilters) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyList */ .n8;
    };
};
var getSolutionSecondLevelFiltersByUID = function(sessionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return ((ref = quizTaking.solutionFilterBySession[sessionUID]) === null || ref === void 0 ? void 0 : ref.solutionSecondLevelFiltersByUID) || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getQuizSolutions = function(key) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.quizSolutions[key];
    };
};
var getQuizSolutionFeedbackOptions = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.solutionFeedbackOptions;
};
var getQuizVideoSolutionFeedbackOptions = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.videoSolutionFeedbackOptions;
};
var getIsSolutionQuestionsaved = function(questionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.solutionSavedQuestions[questionUID];
    };
};
var ref;
var getUserRank = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref1;
        return (ref = (ref1 = quizTaking.rankByQuiz[quizUID]) === null || ref1 === void 0 ? void 0 : ref1.userRank) !== null && ref !== void 0 ? ref : null;
    };
};
var ref1;
var getTotalSessionCount = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return (ref1 = (ref = quizTaking.rankByQuiz[quizUID]) === null || ref === void 0 ? void 0 : ref.totalSessionCount) !== null && ref1 !== void 0 ? ref1 : null;
    };
};
var getEvaluatedSheets = function(param) {
    var quizTaking = param.quizTaking;
    return quizTaking.evaluatedSheetsBySesssion;
};
var getEvaluatedSheet = function(sessionUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.evaluatedSheetsBySesssion[sessionUID] || null;
    };
};
var getFeedbackOptions = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        return quizTaking.feedbackOptionsByUID[quizUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getIsQuizFeedbackGiven = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(quizTaking.feedbackOptionsByUID[quizUID])) {
            return true;
        }
        return !!quizTaking.feedbackOptionsByUID[quizUID].last_submitted_at;
    };
};
var getLiveLeaderboard = function(quizUID) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.quizLeaderboardLive[quizUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getOverallLeaderboard = function(quizUID) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.quizLeaderboardAll[quizUID] || _constants_empty__WEBPACK_IMPORTED_MODULE_1__/* .emptyObject */ .FD;
    };
};
var getLeaderboard = function(quizUID, isLive) {
    return isLive ? getLiveLeaderboard(quizUID) : getOverallLeaderboard(quizUID);
};
var getHasFetchedQuizQuestions = function(quizUID) {
    return function(state) {
        var ref = getQuizDetails(quizUID)(state), _sections = ref.sections, sections = _sections === void 0 ? {} : _sections;
        var questionsBySection = getAllQuestionsBySection(state);
        var sectionsLength = sections.length;
        for(var i = 0; i < sectionsLength; i += 1){
            if (!questionsBySection[sections[i].uid]) {
                return false;
            }
        }
        return true;
    };
};
var getIsQuizForPlusUsers = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref, ref1;
        return (ref = quizTaking.data[quizUID]) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : ref1.for_plus;
    };
};
var getIsUserEnrolledInQuiz = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return (ref = quizTaking.data[quizUID]) === null || ref === void 0 ? void 0 : ref.is_enrolled;
    };
};
var ref2;
var getGoalUId = function(quizUID) {
    return function(param) {
        var quizTaking = param.quizTaking;
        var ref;
        return (ref2 = (ref = quizTaking.data[quizUID]) === null || ref === void 0 ? void 0 : ref.goal_uid) !== null && ref2 !== void 0 ? ref2 : "";
    };
};


/***/ }),

/***/ 97903:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getItemFromSessionStorage = function(item) {
    try {
        return sessionStorage.getItem(item);
    } catch (e) {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getItemFromSessionStorage);


/***/ })

}]);